var items = {
  "block.minecraft.acacia_button": "Bọtini Acacia",
  "block.minecraft.acacia_door": "Acacia enu",
  "block.minecraft.acacia_fence": "Acacia odi",
  "block.minecraft.acacia_fence_gate": "Acacia Ẹnubodè Pada",
  "block.minecraft.acacia_hanging_sign": "Acacia ikele Sign",
  "block.minecraft.acacia_leaves": "Acacia bunkun",
  "block.minecraft.acacia_log": "Acacia Wọle",
  "block.minecraft.acacia_planks": "Apẹrẹ acacia",
  "block.minecraft.acacia_pressure_plate": "Acacia Ipaju awo",
  "block.minecraft.acacia_sapling": "Ororoo igbá",
  "block.minecraft.acacia_shelf": "Acacia Shelf",
  "block.minecraft.acacia_sign": "Akara awo",
  "block.minecraft.acacia_slab": "Akara awo",
  "block.minecraft.acacia_stairs": "Acacia atẹgun",
  "block.minecraft.acacia_trapdoor": "Acacia niye",
  "block.minecraft.acacia_wall_hanging_sign": "Acacia Wall ikele Sign",
  "block.minecraft.acacia_wall_sign": "Acacia Wall Sign",
  "block.minecraft.acacia_wood": "Acacia igi",
  "block.minecraft.activator_rail": "Ibere iṣinipopada",
  "block.minecraft.air": "Afẹfẹ",
  "block.minecraft.allium": "Ata",
  "block.minecraft.amethyst_block": "Àkọsílẹ ti Amethyst",
  "block.minecraft.amethyst_cluster": "Iṣupọ Amethyst",
  "block.minecraft.ancient_debris": "Ibajẹ atijọ",
  "block.minecraft.andesite": "Andesite",
  "block.minecraft.andesite_slab": "Andesite Slab",
  "block.minecraft.andesite_stairs": "Awọn atẹgun Andesite",
  "block.minecraft.andesite_wall": "Andesite Wall",
  "block.minecraft.anvil": "Anvil",
  "block.minecraft.attached_melon_stem": "Sọ Melon Stem",
  "block.minecraft.attached_pumpkin_stem": "Soo elegede tita",
  "block.minecraft.azalea": "Azalea",
  "block.minecraft.azalea_leaves": "Awọn ewe Azalea",
  "block.minecraft.azure_bluet": "Azure Bluet",
  "block.minecraft.bamboo": "Oparun",
  "block.minecraft.bamboo_block": "Oparun ti block",
  "block.minecraft.bamboo_button": "Oparun Bọtini",
  "block.minecraft.bamboo_door": "Oparun ilẹkun",
  "block.minecraft.bamboo_fence": "Odi oparun",
  "block.minecraft.bamboo_fence_gate": "Oparun Ẹnubodè Pada",
  "block.minecraft.bamboo_hanging_sign": "Oparun ikele Sign",
  "block.minecraft.bamboo_mosaic": "Oparun Moseiki",
  "block.minecraft.bamboo_mosaic_slab": "Oparun Moseiki Slab",
  "block.minecraft.bamboo_mosaic_stairs": "Oparun Moseiki Atẹgun",
  "block.minecraft.bamboo_planks": "Oparun Igi",
  "block.minecraft.bamboo_pressure_plate": "Oparun Ipa Plate",
  "block.minecraft.bamboo_sapling": "Oparun Titu",
  "block.minecraft.bamboo_shelf": "Bamboo Shelf",
  "block.minecraft.bamboo_sign": "Oparun ami",
  "block.minecraft.bamboo_slab": "Oparun Slab",
  "block.minecraft.bamboo_stairs": "Oparun Atẹgun",
  "block.minecraft.bamboo_trapdoor": "Oparun Trapdoor",
  "block.minecraft.bamboo_wall_hanging_sign": "Oparun Wall ikele Sign",
  "block.minecraft.bamboo_wall_sign": "Oparun Wall Ami",
  "block.minecraft.banner.base.black": "Ni kikun Black Field",
  "block.minecraft.banner.base.blue": "Aaye Blue ni kikun",
  "block.minecraft.banner.base.brown": "Ni kikun Brown Field",
  "block.minecraft.banner.base.cyan": "Aaye Cyan Ni kikun",
  "block.minecraft.banner.base.gray": "Field Grẹy Ni kikun",
  "block.minecraft.banner.base.green": "Ni kikun Green Field",
  "block.minecraft.banner.base.light_blue": "Aaye Blue Ina Ni kikun",
  "block.minecraft.banner.base.light_gray": "Aaye Grẹy Imọlẹ Ni kikun",
  "block.minecraft.banner.base.lime": "Ni kikun orombo aaye",
  "block.minecraft.banner.base.magenta": "Ni kikun Field Magenta",
  "block.minecraft.banner.base.orange": "Aaye Osan Ni kikun",
  "block.minecraft.banner.base.pink": "Ni kikun Pink Field",
  "block.minecraft.banner.base.purple": "Aaye Pupa Ni kikun",
  "block.minecraft.banner.base.red": "Ni kikun Red Field",
  "block.minecraft.banner.base.white": "Ni kikun Funfun Funfun",
  "block.minecraft.banner.base.yellow": "Aaye Yellow Ni kikun",
  "block.minecraft.banner.border.black": "Black Bordure",
  "block.minecraft.banner.border.blue": "Orombo Aala",
  "block.minecraft.banner.border.brown": "Aala Grey",
  "block.minecraft.banner.border.cyan": "Aala Cyan",
  "block.minecraft.banner.border.gray": "Aala Grey",
  "block.minecraft.banner.border.green": "Aala Grey",
  "block.minecraft.banner.border.light_blue": "Light Blue Bordure",
  "block.minecraft.banner.border.light_gray": "Imọlẹ Grey Bordure",
  "block.minecraft.banner.border.lime": "Orombo Aala",
  "block.minecraft.banner.border.magenta": "Aala Magenta",
  "block.minecraft.banner.border.orange": "Aala Osan",
  "block.minecraft.banner.border.pink": "Aala Pink",
  "block.minecraft.banner.border.purple": "Aala eleyi ti",
  "block.minecraft.banner.border.red": "Red Bordure",
  "block.minecraft.banner.border.white": "Aala Funfun",
  "block.minecraft.banner.border.yellow": "Yellow Bordure",
  "block.minecraft.banner.bricks.black": "Black Field Masoned",
  "block.minecraft.banner.bricks.blue": "Blue Field Masoned",
  "block.minecraft.banner.bricks.brown": "Brown Field Masoned",
  "block.minecraft.banner.bricks.cyan": "Aaye Cyan Masoned",
  "block.minecraft.banner.bricks.gray": "Aaye Grey Masoned",
  "block.minecraft.banner.bricks.green": "Field Green Masoned",
  "block.minecraft.banner.bricks.light_blue": "Light Blue Field Masoned",
  "block.minecraft.banner.bricks.light_gray": "Aaye Imọlẹ Grey Masoned",
  "block.minecraft.banner.bricks.lime": "Lime Field Masoned",
  "block.minecraft.banner.bricks.magenta": "Field Magenta Masoned",
  "block.minecraft.banner.bricks.orange": "Orange Field Masoned",
  "block.minecraft.banner.bricks.pink": "Pink Field Masoned",
  "block.minecraft.banner.bricks.purple": "Aaye eleyi ti Masoned",
  "block.minecraft.banner.bricks.red": "Red Field Masoned",
  "block.minecraft.banner.bricks.white": "Funfun Field Masoned",
  "block.minecraft.banner.bricks.yellow": "Field Yellow Masoned",
  "block.minecraft.banner.circle.black": "Black Roundel",
  "block.minecraft.banner.circle.blue": "Blue Roundel",
  "block.minecraft.banner.circle.brown": "Brown Roundel",
  "block.minecraft.banner.circle.cyan": "Cyan Roundel",
  "block.minecraft.banner.circle.gray": "Grẹy Roundel",
  "block.minecraft.banner.circle.green": "Alawọ ewe Roundel",
  "block.minecraft.banner.circle.light_blue": "Imọlẹ Blue Roundel",
  "block.minecraft.banner.circle.light_gray": "Imọlẹ Grẹy Roundel",
  "block.minecraft.banner.circle.lime": "Orombo Roundel",
  "block.minecraft.banner.circle.magenta": "Magenta Roundel",
  "block.minecraft.banner.circle.orange": "Orange Roundel",
  "block.minecraft.banner.circle.pink": "Pink Roundel",
  "block.minecraft.banner.circle.purple": "Yiyi Roundel",
  "block.minecraft.banner.circle.red": "Red Roundel",
  "block.minecraft.banner.circle.white": "White Roundel",
  "block.minecraft.banner.circle.yellow": "Ofeefee Roundel",
  "block.minecraft.banner.creeper.black": "Black Creeper agbara",
  "block.minecraft.banner.creeper.blue": "Blue Creeper agbara",
  "block.minecraft.banner.creeper.brown": "Brown Creeper agbara",
  "block.minecraft.banner.creeper.cyan": "Idiyele Creeper Cyan",
  "block.minecraft.banner.creeper.gray": "Grey Creeper Charge",
  "block.minecraft.banner.creeper.green": "Green Creeper agbara",
  "block.minecraft.banner.creeper.light_blue": "Light Blue Creeper agbara",
  "block.minecraft.banner.creeper.light_gray": "Light Grey Creeper agbara",
  "block.minecraft.banner.creeper.lime": "Lime Creeper idiyele",
  "block.minecraft.banner.creeper.magenta": "Idiyele Magree Creeper",
  "block.minecraft.banner.creeper.orange": "Osan Creeper agbara",
  "block.minecraft.banner.creeper.pink": "Pink Creeper agbara",
  "block.minecraft.banner.creeper.purple": "Alagbara Creeper Purple",
  "block.minecraft.banner.creeper.red": "Red Creeper agbara",
  "block.minecraft.banner.creeper.white": "White Creeper agbara",
  "block.minecraft.banner.creeper.yellow": "Yellow Creeper agbara",
  "block.minecraft.banner.cross.black": "Saltire Dudu",
  "block.minecraft.banner.cross.blue": "Saltire Bulu",
  "block.minecraft.banner.cross.brown": "Brown Saltire",
  "block.minecraft.banner.cross.cyan": "Cyan Saltire",
  "block.minecraft.banner.cross.gray": "Imọlẹ Gray Saltire",
  "block.minecraft.banner.cross.green": "Green Saltire",
  "block.minecraft.banner.cross.light_blue": "Ina Saltire Blue",
  "block.minecraft.banner.cross.light_gray": "Imọlẹ Grey Saltire",
  "block.minecraft.banner.cross.lime": "Orombo Saltire",
  "block.minecraft.banner.cross.magenta": "Magenta Saltire",
  "block.minecraft.banner.cross.orange": "Ọsan Saltire",
  "block.minecraft.banner.cross.pink": "Pink Saltire",
  "block.minecraft.banner.cross.purple": "Saltire eleyi ti",
  "block.minecraft.banner.cross.red": "Red Saltire",
  "block.minecraft.banner.cross.white": "White Saltire",
  "block.minecraft.banner.cross.yellow": "Saltire Yellow",
  "block.minecraft.banner.curly_border.black": "Black Bordure Indented",
  "block.minecraft.banner.curly_border.blue": "Blue Bordure Indented",
  "block.minecraft.banner.curly_border.brown": "Brown Bordure Indented",
  "block.minecraft.banner.curly_border.cyan": "Cyan Bordure Indented",
  "block.minecraft.banner.curly_border.gray": "Grey Bordure Indented",
  "block.minecraft.banner.curly_border.green": "Green Bordure Indented",
  "block.minecraft.banner.curly_border.light_blue": "Light Blue Bordure Indented",
  "block.minecraft.banner.curly_border.light_gray": "Light Grey Bordure Indented",
  "block.minecraft.banner.curly_border.lime": "Orombo Bordure Indented",
  "block.minecraft.banner.curly_border.magenta": "Magenta Bordure Indented",
  "block.minecraft.banner.curly_border.orange": "Orange Bordure Indented",
  "block.minecraft.banner.curly_border.pink": "Pink Bordure Indented",
  "block.minecraft.banner.curly_border.purple": "Eleyii Bordure Indented",
  "block.minecraft.banner.curly_border.red": "Red Bordure Indented",
  "block.minecraft.banner.curly_border.white": "White Bordure Indented",
  "block.minecraft.banner.curly_border.yellow": "Yellow Bordure Indented",
  "block.minecraft.banner.diagonal_left.black": "Black Per tẹ Sinister",
  "block.minecraft.banner.diagonal_left.blue": "Blue Per tẹ Sinister",
  "block.minecraft.banner.diagonal_left.brown": "Brown Per tẹ Sinister",
  "block.minecraft.banner.diagonal_left.cyan": "Cyan Per tẹ Sinister",
  "block.minecraft.banner.diagonal_left.gray": "Grey Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.green": "Green Per tẹ Sinister",
  "block.minecraft.banner.diagonal_left.light_blue": "Light Blue Per tẹ Sinister",
  "block.minecraft.banner.diagonal_left.light_gray": "Light Grey Per tẹ Sinister",
  "block.minecraft.banner.diagonal_left.lime": "Orombo Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.magenta": "Magenta Per tẹ Sinister",
  "block.minecraft.banner.diagonal_left.orange": "Orange Per tẹ Sinister",
  "block.minecraft.banner.diagonal_left.pink": "Pink Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.purple": "Eleyi ti Fun tẹ Sinister",
  "block.minecraft.banner.diagonal_left.red": "Red Per tẹ Sinister",
  "block.minecraft.banner.diagonal_left.white": "Funfun Fun tẹ Sinister",
  "block.minecraft.banner.diagonal_left.yellow": "Yellow Per tẹ Sinister",
  "block.minecraft.banner.diagonal_right.black": "Black Per Tẹ",
  "block.minecraft.banner.diagonal_right.blue": "Blue Per Tẹ",
  "block.minecraft.banner.diagonal_right.brown": "Brown Fun tẹ",
  "block.minecraft.banner.diagonal_right.cyan": "Cyan Per tẹ",
  "block.minecraft.banner.diagonal_right.gray": "Grẹy Per Tẹ",
  "block.minecraft.banner.diagonal_right.green": "Green Fun tẹ",
  "block.minecraft.banner.diagonal_right.light_blue": "Light Blue Per Tẹ",
  "block.minecraft.banner.diagonal_right.light_gray": "Light Grey Per tẹ",
  "block.minecraft.banner.diagonal_right.lime": "Orombo Fun Tẹ",
  "block.minecraft.banner.diagonal_right.magenta": "Magenta Per tẹ",
  "block.minecraft.banner.diagonal_right.orange": "Orange Fun tẹ",
  "block.minecraft.banner.diagonal_right.pink": "Pink Fun tẹ",
  "block.minecraft.banner.diagonal_right.purple": "Eleyi ti Per tẹ",
  "block.minecraft.banner.diagonal_right.red": "Red Per tẹ",
  "block.minecraft.banner.diagonal_right.white": "Funfun Fun Tẹ",
  "block.minecraft.banner.diagonal_right.yellow": "Yellow Per tẹ",
  "block.minecraft.banner.diagonal_up_left.black": "Black Per tẹ Inverted",
  "block.minecraft.banner.diagonal_up_left.blue": "Blue Per tẹ Sinister",
  "block.minecraft.banner.diagonal_up_left.brown": "Brown Per tẹ Inverted",
  "block.minecraft.banner.diagonal_up_left.cyan": "Cyan Per tẹ Inverted",
  "block.minecraft.banner.diagonal_up_left.gray": "Grẹy Per Tẹ Inverted",
  "block.minecraft.banner.diagonal_up_left.green": "Green Per tẹ Yiyipada",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Light Blue Per tẹ Inverted",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Light Grey Per tẹ Yiyipada",
  "block.minecraft.banner.diagonal_up_left.lime": "Orombo Per Fess Inverted",
  "block.minecraft.banner.diagonal_up_left.magenta": "Magenta Per tẹ Inverted",
  "block.minecraft.banner.diagonal_up_left.orange": "Orange Per tẹ Inverted",
  "block.minecraft.banner.diagonal_up_left.pink": "Pink Per Tẹ Inverted",
  "block.minecraft.banner.diagonal_up_left.purple": "Eleyi ti Per tẹ Inverted",
  "block.minecraft.banner.diagonal_up_left.red": "Red Per tẹ Yiyipada",
  "block.minecraft.banner.diagonal_up_left.white": "Funfun Fun tẹ Yiyipada",
  "block.minecraft.banner.diagonal_up_left.yellow": "Yellow Per Fess Ti Yiyi pada",
  "block.minecraft.banner.diagonal_up_right.black": "Black Per tẹ Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.blue": "Blue Per Tẹ Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.brown": "Brown Per tẹ Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.cyan": "Cyan Fun Tẹ Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.gray": "Grey Per tẹ Sinister Ti yi pada",
  "block.minecraft.banner.diagonal_up_right.green": "Green Per tẹ Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Ina Bulu Fun Tẹ Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Imọlẹ Grey Fun Tẹ Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.lime": "Orombo Fun Tẹ Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.magenta": "Magenta Fun Tẹ Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.orange": "Magenta Fun Tẹ Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.pink": "Pink Per tẹ Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.purple": "Eleyi ti Per tẹ Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.red": "Red Per Bend Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.white": "Funfun Fun Tẹ Sinister Inverted",
  "block.minecraft.banner.diagonal_up_right.yellow": "Yellow Per tẹ Sinister Inverted",
  "block.minecraft.banner.flow.black": "Black Flow",
  "block.minecraft.banner.flow.blue": "Blue Flow",
  "block.minecraft.banner.flow.brown": "Brown Flow",
  "block.minecraft.banner.flow.cyan": "Cyan Flow",
  "block.minecraft.banner.flow.gray": "Gray Flow",
  "block.minecraft.banner.flow.green": "Green Flow",
  "block.minecraft.banner.flow.light_blue": "Light Blue Flow",
  "block.minecraft.banner.flow.light_gray": "Light Gray Flow",
  "block.minecraft.banner.flow.lime": "Lime Flow",
  "block.minecraft.banner.flow.magenta": "Magenta Flow",
  "block.minecraft.banner.flow.orange": "Orange Flow",
  "block.minecraft.banner.flow.pink": "Pink Flow",
  "block.minecraft.banner.flow.purple": "Purple Flow",
  "block.minecraft.banner.flow.red": "Red Flow",
  "block.minecraft.banner.flow.white": "White Flow",
  "block.minecraft.banner.flow.yellow": "Yellow Flow",
  "block.minecraft.banner.flower.black": "Black Flower agbara",
  "block.minecraft.banner.flower.blue": "Blue Flower agbara",
  "block.minecraft.banner.flower.brown": "Owo Ododo Brown",
  "block.minecraft.banner.flower.cyan": "Idiyele Ododo Cyan",
  "block.minecraft.banner.flower.gray": "Grey Flower agbara",
  "block.minecraft.banner.flower.green": "Owo Ododo Alawọ ewe",
  "block.minecraft.banner.flower.light_blue": "Light Blue Flower agbara",
  "block.minecraft.banner.flower.light_gray": "Light Grey Flower agbara",
  "block.minecraft.banner.flower.lime": "Lime Flower agbara",
  "block.minecraft.banner.flower.magenta": "Owo Ododo Magenta",
  "block.minecraft.banner.flower.orange": "Ododo Flower Orange",
  "block.minecraft.banner.flower.pink": "Pink Flower agbara",
  "block.minecraft.banner.flower.purple": "Ododo Ododo Alawọ",
  "block.minecraft.banner.flower.red": "Red Flower agbara",
  "block.minecraft.banner.flower.white": "Owo Ododo Funfun",
  "block.minecraft.banner.flower.yellow": "Yellow Flower agbara",
  "block.minecraft.banner.globe.black": "Black Globe",
  "block.minecraft.banner.globe.blue": "Blue Globe",
  "block.minecraft.banner.globe.brown": "Brown Globe",
  "block.minecraft.banner.globe.cyan": "Cyan Globe",
  "block.minecraft.banner.globe.gray": "Grẹy Globe",
  "block.minecraft.banner.globe.green": "Green Globe",
  "block.minecraft.banner.globe.light_blue": "Light Blue Globe",
  "block.minecraft.banner.globe.light_gray": "Imọlẹ Grey Globe",
  "block.minecraft.banner.globe.lime": "Orombo Globe",
  "block.minecraft.banner.globe.magenta": "Magenta Globe",
  "block.minecraft.banner.globe.orange": "Orange Globe",
  "block.minecraft.banner.globe.pink": "Pink Globe",
  "block.minecraft.banner.globe.purple": "Globe eleyi ti",
  "block.minecraft.banner.globe.red": "Red Globe",
  "block.minecraft.banner.globe.white": "Globe Funfun",
  "block.minecraft.banner.globe.yellow": "Yellow Globe",
  "block.minecraft.banner.gradient.black": "Dudu Alawodudu",
  "block.minecraft.banner.gradient.blue": "Gradient buluu",
  "block.minecraft.banner.gradient.brown": "Gradient Brown",
  "block.minecraft.banner.gradient.cyan": "Gradient Cyan",
  "block.minecraft.banner.gradient.gray": "Gradient Grẹy",
  "block.minecraft.banner.gradient.green": "Gradient Alawọ ewe",
  "block.minecraft.banner.gradient.light_blue": "Gradient Imọlẹ Ina",
  "block.minecraft.banner.gradient.light_gray": "Gradient Imọlẹ Grey",
  "block.minecraft.banner.gradient.lime": "Lime Gradient",
  "block.minecraft.banner.gradient.magenta": "Graentaent Magenta",
  "block.minecraft.banner.gradient.orange": "Gradient Osan",
  "block.minecraft.banner.gradient.pink": "Pink Gradient",
  "block.minecraft.banner.gradient.purple": "Gradient eleyi ti",
  "block.minecraft.banner.gradient.red": "Gradient pupa",
  "block.minecraft.banner.gradient.white": "Gradient funfun",
  "block.minecraft.banner.gradient.yellow": "Gradient ofeefee",
  "block.minecraft.banner.gradient_up.black": "Gradient Ipilẹ Dudu",
  "block.minecraft.banner.gradient_up.blue": "Gradient Ipilẹ Buluu",
  "block.minecraft.banner.gradient_up.brown": "Gradient Mimọ Brown",
  "block.minecraft.banner.gradient_up.cyan": "Gradient Ipilẹ Cyan",
  "block.minecraft.banner.gradient_up.gray": "Gradient Base Grẹy",
  "block.minecraft.banner.gradient_up.green": "Gradient Mimọ Alawọ ewe",
  "block.minecraft.banner.gradient_up.light_blue": "Imọlẹ Blue Base Gradient",
  "block.minecraft.banner.gradient_up.light_gray": "Gradient Base Grey Light",
  "block.minecraft.banner.gradient_up.lime": "Lime Base Gradient",
  "block.minecraft.banner.gradient_up.magenta": "Graentaent Ipilẹ Magenta",
  "block.minecraft.banner.gradient_up.orange": "Gradient Ipilẹ Ọsan",
  "block.minecraft.banner.gradient_up.pink": "Pink Base Gradient",
  "block.minecraft.banner.gradient_up.purple": "Gradient Base Purple",
  "block.minecraft.banner.gradient_up.red": "Red Base Gradient",
  "block.minecraft.banner.gradient_up.white": "Gradient Ipilẹ White",
  "block.minecraft.banner.gradient_up.yellow": "Gradient Yellow Base",
  "block.minecraft.banner.guster.black": "Black Guster",
  "block.minecraft.banner.guster.blue": "Blue Guster",
  "block.minecraft.banner.guster.brown": "Brown Guster",
  "block.minecraft.banner.guster.cyan": "Cyan Guster",
  "block.minecraft.banner.guster.gray": "Gray Guster",
  "block.minecraft.banner.guster.green": "Green Guster",
  "block.minecraft.banner.guster.light_blue": "Light Blue Guster",
  "block.minecraft.banner.guster.light_gray": "Light Gray Guster",
  "block.minecraft.banner.guster.lime": "Lime Guster",
  "block.minecraft.banner.guster.magenta": "Magenta Guster",
  "block.minecraft.banner.guster.orange": "Orange Guster",
  "block.minecraft.banner.guster.pink": "Pink Guster",
  "block.minecraft.banner.guster.purple": "Purple Guster",
  "block.minecraft.banner.guster.red": "Red Guster",
  "block.minecraft.banner.guster.white": "White Guster",
  "block.minecraft.banner.guster.yellow": "Yellow Guster",
  "block.minecraft.banner.half_horizontal.black": "Black Per Fess",
  "block.minecraft.banner.half_horizontal.blue": "Blue Per Fess",
  "block.minecraft.banner.half_horizontal.brown": "Brown Fun Fess",
  "block.minecraft.banner.half_horizontal.cyan": "Cyan Per Fess",
  "block.minecraft.banner.half_horizontal.gray": "Grẹy Per Fess",
  "block.minecraft.banner.half_horizontal.green": "Green Fun Fess",
  "block.minecraft.banner.half_horizontal.light_blue": "Light Blue Per Fess",
  "block.minecraft.banner.half_horizontal.light_gray": "Imọlẹ Grey Per Fess",
  "block.minecraft.banner.half_horizontal.lime": "Orombo Fun Fess",
  "block.minecraft.banner.half_horizontal.magenta": "Magenta Fun Fess",
  "block.minecraft.banner.half_horizontal.orange": "Orange Fun Fess",
  "block.minecraft.banner.half_horizontal.pink": "Pink Fun Fess",
  "block.minecraft.banner.half_horizontal.purple": "Eleyi ti Per Fess",
  "block.minecraft.banner.half_horizontal.red": "Red Per Fess",
  "block.minecraft.banner.half_horizontal.white": "Funfun Fun Fess",
  "block.minecraft.banner.half_horizontal.yellow": "Yellow Per Fess",
  "block.minecraft.banner.half_horizontal_bottom.black": "Black Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Bulu Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Brown Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Cyan Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Grey Per Fess Ti Yiyi pada",
  "block.minecraft.banner.half_horizontal_bottom.green": "Green Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Yellow Per Fess Ti Yiyi pada",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Light Grey Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Orombo Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Magenta Per Fess Yiyipada",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Osan Fun Fess Ti Yiyi",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Pink Per Fess Ti yipada",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Eleyi ti Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.red": "Pupa Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.white": "Osan Fun Fess Ti Yiyi",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Yellow Per Fess Ti Yiyi pada",
  "block.minecraft.banner.half_vertical.black": "Dudu Fun Pale",
  "block.minecraft.banner.half_vertical.blue": "Blue Fun bia",
  "block.minecraft.banner.half_vertical.brown": "Brown Fun bia",
  "block.minecraft.banner.half_vertical.cyan": "Cyan Per Pale",
  "block.minecraft.banner.half_vertical.gray": "Grẹy Fun Pale",
  "block.minecraft.banner.half_vertical.green": "Green Fun bia",
  "block.minecraft.banner.half_vertical.light_blue": "Light Blue Per bia",
  "block.minecraft.banner.half_vertical.light_gray": "Light Grey Per bia",
  "block.minecraft.banner.half_vertical.lime": "Orombo Fun Awọn ṣọọbu",
  "block.minecraft.banner.half_vertical.magenta": "Magenta Fun Pale",
  "block.minecraft.banner.half_vertical.orange": "Osan Fun Pale",
  "block.minecraft.banner.half_vertical.pink": "Pink Fun bia",
  "block.minecraft.banner.half_vertical.purple": "Eleyi ti Perle",
  "block.minecraft.banner.half_vertical.red": "Pupa Fun Pale",
  "block.minecraft.banner.half_vertical.white": "Funfun Fun Pa",
  "block.minecraft.banner.half_vertical.yellow": "Yellow Per bia",
  "block.minecraft.banner.half_vertical_right.black": "Black Per bia Inverted",
  "block.minecraft.banner.half_vertical_right.blue": "Blue Per bia Inverted",
  "block.minecraft.banner.half_vertical_right.brown": "Brown Per bia Inverted",
  "block.minecraft.banner.half_vertical_right.cyan": "Cyan Per bia Inverted",
  "block.minecraft.banner.half_vertical_right.gray": "Grẹy Per bia Inverted",
  "block.minecraft.banner.half_vertical_right.green": "Green Per bia Yiyipada",
  "block.minecraft.banner.half_vertical_right.light_blue": "Light Blue Per bia Inverted",
  "block.minecraft.banner.half_vertical_right.light_gray": "Light Gray Per bia Inverted",
  "block.minecraft.banner.half_vertical_right.lime": "Lime Per bia Inverted",
  "block.minecraft.banner.half_vertical_right.magenta": "Magenta Per Pale Ti Yiyi",
  "block.minecraft.banner.half_vertical_right.orange": "Orange Per bia Inverted",
  "block.minecraft.banner.half_vertical_right.pink": "Pink Per bia Inverted",
  "block.minecraft.banner.half_vertical_right.purple": "Eleyi ti Per bia Inverted",
  "block.minecraft.banner.half_vertical_right.red": "Red Per bia Inverted",
  "block.minecraft.banner.half_vertical_right.white": "Funfun Fun Pale Ti Yiyi",
  "block.minecraft.banner.half_vertical_right.yellow": "Yellow Per bia Inverted",
  "block.minecraft.banner.mojang.black": "Ohun dudu",
  "block.minecraft.banner.mojang.blue": "Ohun Blue",
  "block.minecraft.banner.mojang.brown": "Ohun Brown",
  "block.minecraft.banner.mojang.cyan": "Ohun Cyan",
  "block.minecraft.banner.mojang.gray": "Ohun Grẹy",
  "block.minecraft.banner.mojang.green": "Ohun Alawọ ewe",
  "block.minecraft.banner.mojang.light_blue": "Light Blue Nkan",
  "block.minecraft.banner.mojang.light_gray": "Ohun Grey Light",
  "block.minecraft.banner.mojang.lime": "Ohun orombo wewe",
  "block.minecraft.banner.mojang.magenta": "Magenta Nkan",
  "block.minecraft.banner.mojang.orange": "Ohun Osan",
  "block.minecraft.banner.mojang.pink": "Ohun Pink",
  "block.minecraft.banner.mojang.purple": "Ohun Alawọ",
  "block.minecraft.banner.mojang.red": "Ohun pupa",
  "block.minecraft.banner.mojang.white": "Ohun Funfun",
  "block.minecraft.banner.mojang.yellow": "Ohun ofeefee",
  "block.minecraft.banner.piglin.black": "Didan imu dudu",
  "block.minecraft.banner.piglin.blue": "Irun didan",
  "block.minecraft.banner.piglin.brown": "Irun brown",
  "block.minecraft.banner.piglin.cyan": "Ẹgbẹ turquoise",
  "block.minecraft.banner.piglin.gray": "Oorun grẹy",
  "block.minecraft.banner.piglin.green": "Igba Iso alawọ ewe",
  "block.minecraft.banner.piglin.light_blue": "Irun didan",
  "block.minecraft.banner.piglin.light_gray": "Ina grẹy ina",
  "block.minecraft.banner.piglin.lime": "Orombo orombo",
  "block.minecraft.banner.piglin.magenta": "Ẹmi mimu",
  "block.minecraft.banner.piglin.orange": "Igba rirun osan",
  "block.minecraft.banner.piglin.pink": "Awọ pupa",
  "block.minecraft.banner.piglin.purple": "Ẹmi mimu",
  "block.minecraft.banner.piglin.red": "Iso pupa",
  "block.minecraft.banner.piglin.white": "Igba funfun",
  "block.minecraft.banner.piglin.yellow": "Igba Iwo ofeefee",
  "block.minecraft.banner.rhombus.black": "Black Lozenge",
  "block.minecraft.banner.rhombus.blue": "Blue Lozenge",
  "block.minecraft.banner.rhombus.brown": "Brown Lozenge",
  "block.minecraft.banner.rhombus.cyan": "Cyan Lozenge",
  "block.minecraft.banner.rhombus.gray": "Grey Lozenge",
  "block.minecraft.banner.rhombus.green": "Green Lozenge",
  "block.minecraft.banner.rhombus.light_blue": "Imọlẹ Blue Lozenge",
  "block.minecraft.banner.rhombus.light_gray": "Ina Gray Lozenge",
  "block.minecraft.banner.rhombus.lime": "Orombo Lozenge",
  "block.minecraft.banner.rhombus.magenta": "Magenta Lozenge",
  "block.minecraft.banner.rhombus.orange": "Osan Lozenge",
  "block.minecraft.banner.rhombus.pink": "Pink Lozenge",
  "block.minecraft.banner.rhombus.purple": "Eleyi ti Lozenge",
  "block.minecraft.banner.rhombus.red": "Pupa Lozenge",
  "block.minecraft.banner.rhombus.white": "White Lozenge",
  "block.minecraft.banner.rhombus.yellow": "Yellow Lozenge",
  "block.minecraft.banner.skull.black": "Black Skull idiyele",
  "block.minecraft.banner.skull.blue": "Blue Skull idiyele",
  "block.minecraft.banner.skull.brown": "Brown Skull idiyele",
  "block.minecraft.banner.skull.cyan": "Idiyele Timole Cyan",
  "block.minecraft.banner.skull.gray": "Grey Skull Skrege",
  "block.minecraft.banner.skull.green": "Green Skull idiyele",
  "block.minecraft.banner.skull.light_blue": "Light Blue Skull Charge",
  "block.minecraft.banner.skull.light_gray": "Light Grey Skull idiyele",
  "block.minecraft.banner.skull.lime": "Lime Skull idiyele",
  "block.minecraft.banner.skull.magenta": "Idiyele Timole Magenta",
  "block.minecraft.banner.skull.orange": "Orange Skull idiyele",
  "block.minecraft.banner.skull.pink": "Pink Timole idiyele",
  "block.minecraft.banner.skull.purple": "Idiyele Timole Ododo",
  "block.minecraft.banner.skull.red": "Red Skull idiyele",
  "block.minecraft.banner.skull.white": "White Skull idiyele",
  "block.minecraft.banner.skull.yellow": "Yellow Skull idiyele",
  "block.minecraft.banner.small_stripes.black": "Black Paly",
  "block.minecraft.banner.small_stripes.blue": "Blue Paly",
  "block.minecraft.banner.small_stripes.brown": "Brown Paly",
  "block.minecraft.banner.small_stripes.cyan": "Cyan bia",
  "block.minecraft.banner.small_stripes.gray": "Grey Paly",
  "block.minecraft.banner.small_stripes.green": "Alawọ ewe Paly",
  "block.minecraft.banner.small_stripes.light_blue": "Imọlẹ Blue Paly",
  "block.minecraft.banner.small_stripes.light_gray": "Imọlẹ Grey Paly",
  "block.minecraft.banner.small_stripes.lime": "Orombo Dun",
  "block.minecraft.banner.small_stripes.magenta": "Magenta Paly",
  "block.minecraft.banner.small_stripes.orange": "Orange Paly",
  "block.minecraft.banner.small_stripes.pink": "Pink Paly",
  "block.minecraft.banner.small_stripes.purple": "Paly eleyi",
  "block.minecraft.banner.small_stripes.red": "Pupa Paly",
  "block.minecraft.banner.small_stripes.white": "White Paly",
  "block.minecraft.banner.small_stripes.yellow": "Yellow Ṣiṣẹ",
  "block.minecraft.banner.square_bottom_left.black": "Black Mimọ Dexter Canton",
  "block.minecraft.banner.square_bottom_left.blue": "Blue Chief Sinister Canton",
  "block.minecraft.banner.square_bottom_left.brown": "Brown Chief Sinister Canton",
  "block.minecraft.banner.square_bottom_left.cyan": "Cyan Mimọ Dexter Canton",
  "block.minecraft.banner.square_bottom_left.gray": "Grey Mimọ Dexter Canton",
  "block.minecraft.banner.square_bottom_left.green": "Green Chief Sinister Canton",
  "block.minecraft.banner.square_bottom_left.light_blue": "Imọlẹ Blue Base Dexter Canton",
  "block.minecraft.banner.square_bottom_left.light_gray": "Light Gray Mimọ Dexter Canton",
  "block.minecraft.banner.square_bottom_left.lime": "Orombo Mimọ Dexter Canton",
  "block.minecraft.banner.square_bottom_left.magenta": "Magenta Mimọ Dexter Canton",
  "block.minecraft.banner.square_bottom_left.orange": "Osan Mimọ Dexter Canton",
  "block.minecraft.banner.square_bottom_left.pink": "Pink Mimọ Dexter Canton",
  "block.minecraft.banner.square_bottom_left.purple": "Purple Chief Sinister Canton",
  "block.minecraft.banner.square_bottom_left.red": "Red Chief Sinister Canton",
  "block.minecraft.banner.square_bottom_left.white": "White Base Dexter Canton",
  "block.minecraft.banner.square_bottom_left.yellow": "Yellow Mimọ Dexter Canton",
  "block.minecraft.banner.square_bottom_right.black": "Black Mimọ Sinister Canton",
  "block.minecraft.banner.square_bottom_right.blue": "Blue Base Sinister Canton",
  "block.minecraft.banner.square_bottom_right.brown": "Brown Mimọ Sinister Canton",
  "block.minecraft.banner.square_bottom_right.cyan": "Cyan Mimọ Sinister Canton",
  "block.minecraft.banner.square_bottom_right.gray": "Gray Mimọ Sinister Canton",
  "block.minecraft.banner.square_bottom_right.green": "Green Mimọ Sinister Canton",
  "block.minecraft.banner.square_bottom_right.light_blue": "Imọlẹ Blue Base Sinister Canton",
  "block.minecraft.banner.square_bottom_right.light_gray": "Light Gray Mimọ Sinister Canton",
  "block.minecraft.banner.square_bottom_right.lime": "Orombo Mimọ Sinister Canton",
  "block.minecraft.banner.square_bottom_right.magenta": "Magenta Mimọ Sinister Canton",
  "block.minecraft.banner.square_bottom_right.orange": "Osan Mimọ Sinister Canton",
  "block.minecraft.banner.square_bottom_right.pink": "Pink Mimọ Sinister Canton",
  "block.minecraft.banner.square_bottom_right.purple": "Eleyi ti Base Sinister Canton",
  "block.minecraft.banner.square_bottom_right.red": "Red Base Sinister Canton",
  "block.minecraft.banner.square_bottom_right.white": "White Base Sinister Canton",
  "block.minecraft.banner.square_bottom_right.yellow": "Yellow Mimọ Sinister Canton",
  "block.minecraft.banner.square_top_left.black": "Black Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.blue": "Blue Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.brown": "Brown Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.cyan": "Cyan Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.gray": "Grey Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.green": "Green Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.light_blue": "Imọlẹ Blue Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.light_gray": "Olori Grey Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.lime": "Orombo Olori Dexter Canton",
  "block.minecraft.banner.square_top_left.magenta": "Magenta Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.orange": "Olomi Oloye Dexter Canton",
  "block.minecraft.banner.square_top_left.pink": "Pink Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.purple": "Eleyi ti Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.red": "Red Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.white": "White Chief Dexter Canton",
  "block.minecraft.banner.square_top_left.yellow": "Yellow Chief Dexter Canton",
  "block.minecraft.banner.square_top_right.black": "Black Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.blue": "Blue Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.brown": "Brown Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.cyan": "Cyan Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.gray": "Grey Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.green": "Green Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.light_blue": "Imọlẹ Blue Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.light_gray": "Light Gray Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.lime": "Orombo Olori Sinister Canton",
  "block.minecraft.banner.square_top_right.magenta": "Magenta Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.orange": "Olomi Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.pink": "Pink Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.purple": "Eleyi ti Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.red": "Red Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.white": "White Chief Sinister Canton",
  "block.minecraft.banner.square_top_right.yellow": "Yellow Chief Sinister Canton",
  "block.minecraft.banner.straight_cross.black": "Black Cross",
  "block.minecraft.banner.straight_cross.blue": "Blue Cross",
  "block.minecraft.banner.straight_cross.brown": "Brown Cross",
  "block.minecraft.banner.straight_cross.cyan": "Cross Cyan",
  "block.minecraft.banner.straight_cross.gray": "Grẹy Fess",
  "block.minecraft.banner.straight_cross.green": "Green Cross",
  "block.minecraft.banner.straight_cross.light_blue": "Imọlẹ Blue Fess",
  "block.minecraft.banner.straight_cross.light_gray": "Imọlẹ Grẹy Fess",
  "block.minecraft.banner.straight_cross.lime": "Orombo Fess",
  "block.minecraft.banner.straight_cross.magenta": "Magenta Fess",
  "block.minecraft.banner.straight_cross.orange": "Osan Osan",
  "block.minecraft.banner.straight_cross.pink": "Pink Fess",
  "block.minecraft.banner.straight_cross.purple": "Agbelebu Purple",
  "block.minecraft.banner.straight_cross.red": "Red Cross",
  "block.minecraft.banner.straight_cross.white": "Orombo Fess",
  "block.minecraft.banner.straight_cross.yellow": "Fess ofeefee",
  "block.minecraft.banner.stripe_bottom.black": "Black Mimọ",
  "block.minecraft.banner.stripe_bottom.blue": "Ipilẹ Blue",
  "block.minecraft.banner.stripe_bottom.brown": "Brown Ipilẹ",
  "block.minecraft.banner.stripe_bottom.cyan": "Ipilẹ Cyan",
  "block.minecraft.banner.stripe_bottom.gray": "Grẹy Mimọ",
  "block.minecraft.banner.stripe_bottom.green": "Ipilẹ Alawọ ewe",
  "block.minecraft.banner.stripe_bottom.light_blue": "Imọlẹ Blue Base",
  "block.minecraft.banner.stripe_bottom.light_gray": "Imọlẹ Grẹy Light",
  "block.minecraft.banner.stripe_bottom.lime": "Orombo Mimọ",
  "block.minecraft.banner.stripe_bottom.magenta": "Magenta Mimọ",
  "block.minecraft.banner.stripe_bottom.orange": "Mimọ Osan",
  "block.minecraft.banner.stripe_bottom.pink": "Ipilẹ Pink",
  "block.minecraft.banner.stripe_bottom.purple": "Ipilẹ eleyi ti",
  "block.minecraft.banner.stripe_bottom.red": "Red Mimọ",
  "block.minecraft.banner.stripe_bottom.white": "White Mimọ",
  "block.minecraft.banner.stripe_bottom.yellow": "Mimọ Yellow",
  "block.minecraft.banner.stripe_center.black": "Black Mimọ",
  "block.minecraft.banner.stripe_center.blue": "Blue bia",
  "block.minecraft.banner.stripe_center.brown": "Brown bia",
  "block.minecraft.banner.stripe_center.cyan": "Cyan bia",
  "block.minecraft.banner.stripe_center.gray": "Grẹy bia",
  "block.minecraft.banner.stripe_center.green": "Imọlẹ Alawọ ewe",
  "block.minecraft.banner.stripe_center.light_blue": "Ina Bulu Ina",
  "block.minecraft.banner.stripe_center.light_gray": "Imọlẹ Grẹy Light",
  "block.minecraft.banner.stripe_center.lime": "Orombo bia",
  "block.minecraft.banner.stripe_center.magenta": "Magenta bia",
  "block.minecraft.banner.stripe_center.orange": "Osan Osan",
  "block.minecraft.banner.stripe_center.pink": "Pink bia",
  "block.minecraft.banner.stripe_center.purple": "Bia eleyi ti",
  "block.minecraft.banner.stripe_center.red": "Pupa bia",
  "block.minecraft.banner.stripe_center.white": "White bia",
  "block.minecraft.banner.stripe_center.yellow": "Awọ ofeefee",
  "block.minecraft.banner.stripe_downleft.black": "Black tẹ Sinister",
  "block.minecraft.banner.stripe_downleft.blue": "Blue Tẹ Sinister",
  "block.minecraft.banner.stripe_downleft.brown": "Brown tẹ Sinister",
  "block.minecraft.banner.stripe_downleft.cyan": "Cyan Tẹ Sinister",
  "block.minecraft.banner.stripe_downleft.gray": "Grey tẹ Sinister",
  "block.minecraft.banner.stripe_downleft.green": "Green tẹ Sinister",
  "block.minecraft.banner.stripe_downleft.light_blue": "Ina Blue tẹ Sinister",
  "block.minecraft.banner.stripe_downleft.light_gray": "Light Gray tẹ Sinister",
  "block.minecraft.banner.stripe_downleft.lime": "Orombo tẹ Sinister",
  "block.minecraft.banner.stripe_downleft.magenta": "Magenta Tẹ Sinister",
  "block.minecraft.banner.stripe_downleft.orange": "Osan Tẹ Sinister",
  "block.minecraft.banner.stripe_downleft.pink": "Pink tẹ Sinister",
  "block.minecraft.banner.stripe_downleft.purple": "Eleyi ti tẹ Sinister",
  "block.minecraft.banner.stripe_downleft.red": "Red tẹ Sinister",
  "block.minecraft.banner.stripe_downleft.white": "Funfun Tẹ Sinister",
  "block.minecraft.banner.stripe_downleft.yellow": "Yellow tẹ Sinister",
  "block.minecraft.banner.stripe_downright.black": "Black tẹ",
  "block.minecraft.banner.stripe_downright.blue": "Bulu Tẹ",
  "block.minecraft.banner.stripe_downright.brown": "Brown tẹ",
  "block.minecraft.banner.stripe_downright.cyan": "Cyan tẹ",
  "block.minecraft.banner.stripe_downright.gray": "Gray tẹ",
  "block.minecraft.banner.stripe_downright.green": "Green tẹ",
  "block.minecraft.banner.stripe_downright.light_blue": "Ina Blue Tẹ",
  "block.minecraft.banner.stripe_downright.light_gray": "Ina Gray Tẹ",
  "block.minecraft.banner.stripe_downright.lime": "Lime tẹ",
  "block.minecraft.banner.stripe_downright.magenta": "Magenta Tẹ",
  "block.minecraft.banner.stripe_downright.orange": "Tẹ Orange",
  "block.minecraft.banner.stripe_downright.pink": "Pink tẹ",
  "block.minecraft.banner.stripe_downright.purple": "Tẹ eleyi ti",
  "block.minecraft.banner.stripe_downright.red": "Red tẹ",
  "block.minecraft.banner.stripe_downright.white": "Funfun Tẹ",
  "block.minecraft.banner.stripe_downright.yellow": "Yẹ tẹẹrẹ",
  "block.minecraft.banner.stripe_left.black": "Black bia Dexter",
  "block.minecraft.banner.stripe_left.blue": "Blue Dile Dexter",
  "block.minecraft.banner.stripe_left.brown": "Brown bia Dexter",
  "block.minecraft.banner.stripe_left.cyan": "Cyan bia Dexter",
  "block.minecraft.banner.stripe_left.gray": "Grey bia Dexter",
  "block.minecraft.banner.stripe_left.green": "Green bia Dexter",
  "block.minecraft.banner.stripe_left.light_blue": "Ina Dexter Bulu Onitẹlẹ",
  "block.minecraft.banner.stripe_left.light_gray": "Ina Grey bia Dexter",
  "block.minecraft.banner.stripe_left.lime": "Orombo bia Dexter",
  "block.minecraft.banner.stripe_left.magenta": "Magenta bia Dexter",
  "block.minecraft.banner.stripe_left.orange": "Dexter Osan bia",
  "block.minecraft.banner.stripe_left.pink": "Pink bia Dexter",
  "block.minecraft.banner.stripe_left.purple": "Dexter bia eleyi ti",
  "block.minecraft.banner.stripe_left.red": "Red bia Dexter",
  "block.minecraft.banner.stripe_left.white": "White bia Dexter",
  "block.minecraft.banner.stripe_left.yellow": "Dexter bia bia",
  "block.minecraft.banner.stripe_middle.black": "Dudu Fess",
  "block.minecraft.banner.stripe_middle.blue": "Blue Fess",
  "block.minecraft.banner.stripe_middle.brown": "Brown Fess",
  "block.minecraft.banner.stripe_middle.cyan": "Cyan Fess",
  "block.minecraft.banner.stripe_middle.gray": "Grẹy Fess",
  "block.minecraft.banner.stripe_middle.green": "Awọn ọya Green",
  "block.minecraft.banner.stripe_middle.light_blue": "Imọlẹ Blue Fess",
  "block.minecraft.banner.stripe_middle.light_gray": "Imọlẹ Grẹy Fess",
  "block.minecraft.banner.stripe_middle.lime": "Orombo Fess",
  "block.minecraft.banner.stripe_middle.magenta": "Magenta Fess",
  "block.minecraft.banner.stripe_middle.orange": "Osan Osan",
  "block.minecraft.banner.stripe_middle.pink": "Pink Fess",
  "block.minecraft.banner.stripe_middle.purple": "Fess eleyi ti",
  "block.minecraft.banner.stripe_middle.red": "Red Fess",
  "block.minecraft.banner.stripe_middle.white": "Funfun Fess",
  "block.minecraft.banner.stripe_middle.yellow": "Fess ofeefee",
  "block.minecraft.banner.stripe_right.black": "Black bia Sinister",
  "block.minecraft.banner.stripe_right.blue": "Blue bia Sinister",
  "block.minecraft.banner.stripe_right.brown": "Brown bia Sinister",
  "block.minecraft.banner.stripe_right.cyan": "Cyan bia Sinister",
  "block.minecraft.banner.stripe_right.gray": "Grẹy bia ominous",
  "block.minecraft.banner.stripe_right.green": "Green bia Sinister",
  "block.minecraft.banner.stripe_right.light_blue": "Light Blue Pale Sinister",
  "block.minecraft.banner.stripe_right.light_gray": "Light Gray bia Sinister",
  "block.minecraft.banner.stripe_right.lime": "Orombo bia Sinister",
  "block.minecraft.banner.stripe_right.magenta": "Magenta bia Sinister",
  "block.minecraft.banner.stripe_right.orange": "Osan bia Sinister",
  "block.minecraft.banner.stripe_right.pink": "Pink bia Sinister",
  "block.minecraft.banner.stripe_right.purple": "Sinister bia",
  "block.minecraft.banner.stripe_right.red": "Red bia Sinister",
  "block.minecraft.banner.stripe_right.white": "White Pale Sinister",
  "block.minecraft.banner.stripe_right.yellow": "Yellow bia Sinister",
  "block.minecraft.banner.stripe_top.black": "Olori Dudu",
  "block.minecraft.banner.stripe_top.blue": "Olori buluu",
  "block.minecraft.banner.stripe_top.brown": "Brown Chief",
  "block.minecraft.banner.stripe_top.cyan": "Chief Cyan",
  "block.minecraft.banner.stripe_top.gray": "Grey Chief",
  "block.minecraft.banner.stripe_top.green": "Olori Alawọ ewe",
  "block.minecraft.banner.stripe_top.light_blue": "Imọlẹ Blue Chief",
  "block.minecraft.banner.stripe_top.light_gray": "Olori Grẹy Light",
  "block.minecraft.banner.stripe_top.lime": "Olomi orombo",
  "block.minecraft.banner.stripe_top.magenta": "Magenta Chief",
  "block.minecraft.banner.stripe_top.orange": "Olori Osan",
  "block.minecraft.banner.stripe_top.pink": "Olori Pink",
  "block.minecraft.banner.stripe_top.purple": "Olori eleyi",
  "block.minecraft.banner.stripe_top.red": "Red Chief",
  "block.minecraft.banner.stripe_top.white": "Olori Funfun",
  "block.minecraft.banner.stripe_top.yellow": "Yellow Chief",
  "block.minecraft.banner.triangle_bottom.black": "Black Chevron",
  "block.minecraft.banner.triangle_bottom.blue": "Blue Chevron",
  "block.minecraft.banner.triangle_bottom.brown": "Brown Chevron",
  "block.minecraft.banner.triangle_bottom.cyan": "Cyan Chevron",
  "block.minecraft.banner.triangle_bottom.gray": "Grey Chevron",
  "block.minecraft.banner.triangle_bottom.green": "Alawọ ewe Chevron",
  "block.minecraft.banner.triangle_bottom.light_blue": "Ina Blue Chevron",
  "block.minecraft.banner.triangle_bottom.light_gray": "Imọlẹ Grey Chevron",
  "block.minecraft.banner.triangle_bottom.lime": "Orombo Chevron",
  "block.minecraft.banner.triangle_bottom.magenta": "Magenta Chevron",
  "block.minecraft.banner.triangle_bottom.orange": "Osan Chevron",
  "block.minecraft.banner.triangle_bottom.pink": "Pink Chevron",
  "block.minecraft.banner.triangle_bottom.purple": "Eleyi ti Chevron",
  "block.minecraft.banner.triangle_bottom.red": "Pupa Chevron",
  "block.minecraft.banner.triangle_bottom.white": "White Chevron",
  "block.minecraft.banner.triangle_bottom.yellow": "Yellow Chevron",
  "block.minecraft.banner.triangle_top.black": "Dudu Iyipada Chevron",
  "block.minecraft.banner.triangle_top.blue": "Bulu Inverted Chevron",
  "block.minecraft.banner.triangle_top.brown": "Brown Inverted Chevron",
  "block.minecraft.banner.triangle_top.cyan": "Cyan Inverted Chevron",
  "block.minecraft.banner.triangle_top.gray": "Grẹy Inverted Chevron",
  "block.minecraft.banner.triangle_top.green": "Green Inverted Chevron",
  "block.minecraft.banner.triangle_top.light_blue": "Light Chevron Yiyi Buluu",
  "block.minecraft.banner.triangle_top.light_gray": "Imọlẹ Gray Iyipo Chevron",
  "block.minecraft.banner.triangle_top.lime": "Orombo Inverted Chevron",
  "block.minecraft.banner.triangle_top.magenta": "Magenta Inverted Chevron",
  "block.minecraft.banner.triangle_top.orange": "Osan Inverted Chevron",
  "block.minecraft.banner.triangle_top.pink": "Pink Inverted Chevron",
  "block.minecraft.banner.triangle_top.purple": "Chevron eleyi ti Yiyi",
  "block.minecraft.banner.triangle_top.red": "Red inverted Chevron",
  "block.minecraft.banner.triangle_top.white": "Funfun Iyipada Chevron",
  "block.minecraft.banner.triangle_top.yellow": "Yellow Inverted Chevron",
  "block.minecraft.banner.triangles_bottom.black": "Black mimọ Indented",
  "block.minecraft.banner.triangles_bottom.blue": "Blue Base Indented",
  "block.minecraft.banner.triangles_bottom.brown": "Brown mimọ Indented",
  "block.minecraft.banner.triangles_bottom.cyan": "Cyan Mimọ Indented",
  "block.minecraft.banner.triangles_bottom.gray": "Gray Mimọ Indented",
  "block.minecraft.banner.triangles_bottom.green": "Green mimọ Indented",
  "block.minecraft.banner.triangles_bottom.light_blue": "Yellow Mimọ Indented",
  "block.minecraft.banner.triangles_bottom.light_gray": "Imọlẹ Gray Mimọ Indented",
  "block.minecraft.banner.triangles_bottom.lime": "Orombo Mimọ Indented",
  "block.minecraft.banner.triangles_bottom.magenta": "Yellow Mimọ Indented",
  "block.minecraft.banner.triangles_bottom.orange": "Orange Mimọ Indented",
  "block.minecraft.banner.triangles_bottom.pink": "Pink Mimọ Indented",
  "block.minecraft.banner.triangles_bottom.purple": "Purple Mimọ Indented",
  "block.minecraft.banner.triangles_bottom.red": "Red mimọ Indented",
  "block.minecraft.banner.triangles_bottom.white": "White mimọ Indented",
  "block.minecraft.banner.triangles_bottom.yellow": "Yellow Mimọ Indented",
  "block.minecraft.banner.triangles_top.black": "Black Chief Indented",
  "block.minecraft.banner.triangles_top.blue": "Blue Chief Indented",
  "block.minecraft.banner.triangles_top.brown": "Brown Chief Indented",
  "block.minecraft.banner.triangles_top.cyan": "Cyan Chief Indented",
  "block.minecraft.banner.triangles_top.gray": "Light Gray Chief Indented",
  "block.minecraft.banner.triangles_top.green": "Green Chief Indented",
  "block.minecraft.banner.triangles_top.light_blue": "Ina Blue Chief Indented",
  "block.minecraft.banner.triangles_top.light_gray": "Light Gray Chief Indented",
  "block.minecraft.banner.triangles_top.lime": "Orombo Oloye Indented",
  "block.minecraft.banner.triangles_top.magenta": "Magenta Chief Indented",
  "block.minecraft.banner.triangles_top.orange": "Oloye Oloye Indented",
  "block.minecraft.banner.triangles_top.pink": "Pink Chief Indented",
  "block.minecraft.banner.triangles_top.purple": "Purple Chief Indented",
  "block.minecraft.banner.triangles_top.red": "Pupa Chief Indented",
  "block.minecraft.banner.triangles_top.white": "Funfun Chief Indented",
  "block.minecraft.banner.triangles_top.yellow": "Yellow Chief Indented",
  "block.minecraft.barrel": "Aṣayan ti a ko mọ",
  "block.minecraft.barrier": "Idankan",
  "block.minecraft.basalt": "Basalt",
  "block.minecraft.beacon": "Beakoni",
  "block.minecraft.beacon.primary": "Agbara Akọkọ",
  "block.minecraft.beacon.secondary": "Agbara Atẹle",
  "block.minecraft.bed.no_sleep": "O le sun nikan ni alẹ tabi lakoko iji ojo",
  "block.minecraft.bed.not_safe": "O le ma sinmi bayi; ohun ibanilẹru wa nitosi",
  "block.minecraft.bed.obstructed": "Ibo yii ti ni idena",
  "block.minecraft.bed.occupied": "Ibo yii ti tẹdo",
  "block.minecraft.bed.too_far_away": "O le ma sinmi bayi; ibusun naa jina ju lọ",
  "block.minecraft.bedrock": "Lya apata",
  "block.minecraft.bee_nest": "Bee itẹ-ẹiyẹ",
  "block.minecraft.beehive": "Bee",
  "block.minecraft.beetroots": "Beet",
  "block.minecraft.bell": "Belii",
  "block.minecraft.big_dripleaf": "Big Dripleaf",
  "block.minecraft.big_dripleaf_stem": "Big Dripleaf Stem",
  "block.minecraft.birch_button": "Bọtini Birch",
  "block.minecraft.birch_door": "Birch enu",
  "block.minecraft.birch_fence": "Birch odi",
  "block.minecraft.birch_fence_gate": "Birch Ẹnubodè Pada",
  "block.minecraft.birch_hanging_sign": "Birch ikele Sign",
  "block.minecraft.birch_leaves": "Birch bunkun",
  "block.minecraft.birch_log": "Birch Wọle",
  "block.minecraft.birch_planks": "Ile-iṣẹ Birch",
  "block.minecraft.birch_pressure_plate": "Birch Ipa titẹ",
  "block.minecraft.birch_sapling": "Ororoo birch",
  "block.minecraft.birch_shelf": "Birch Shelf",
  "block.minecraft.birch_sign": "Birch awo",
  "block.minecraft.birch_slab": "Birch awo",
  "block.minecraft.birch_stairs": "Birch atẹgun",
  "block.minecraft.birch_trapdoor": "Birch niye",
  "block.minecraft.birch_wall_hanging_sign": "Birch Wall ikele Sign",
  "block.minecraft.birch_wall_sign": "Birch Wall Sign",
  "block.minecraft.birch_wood": "Birch igi",
  "block.minecraft.black_banner": "Asia Dudu",
  "block.minecraft.black_bed": "Ibusun Dudu",
  "block.minecraft.black_candle": "Dudu Abẹla",
  "block.minecraft.black_candle_cake": "Akara oyinbo pẹlu dudu abẹla",
  "block.minecraft.black_carpet": "Dudu carpeti",
  "block.minecraft.black_concrete": "Nkan dudu",
  "block.minecraft.black_concrete_powder": "Dudu lulú fẹẹrẹ",
  "block.minecraft.black_glazed_terracotta": "Dudu Glazed Terracotta",
  "block.minecraft.black_shulker_box": "Apoti Shulker Dudu",
  "block.minecraft.black_stained_glass": "Dudu gilasi",
  "block.minecraft.black_stained_glass_pane": "Dudu gilasi",
  "block.minecraft.black_terracotta": "Dudu terakota",
  "block.minecraft.black_wool": "Dudu kìki irun",
  "block.minecraft.blackstone": "Okuta dudu",
  "block.minecraft.blackstone_slab": "Apẹrẹ gusu",
  "block.minecraft.blackstone_stairs": "Ile ogiri dudu",
  "block.minecraft.blackstone_wall": "Dudu odi dudu",
  "block.minecraft.blast_furnace": "Blast Furnace",
  "block.minecraft.blue_banner": "Asia Blue",
  "block.minecraft.blue_bed": "Bulu Ibusun",
  "block.minecraft.blue_candle": "Bulu Abẹla",
  "block.minecraft.blue_candle_cake": "Akara oyinbo pẹlu Bulu abẹla",
  "block.minecraft.blue_carpet": "Bulu carpeti",
  "block.minecraft.blue_concrete": "Imọlẹ Buluu",
  "block.minecraft.blue_concrete_powder": "Ipara lulú",
  "block.minecraft.blue_glazed_terracotta": "Glazed Terracotta",
  "block.minecraft.blue_ice": "Bulu yinyin",
  "block.minecraft.blue_orchid": "Bulu orchid",
  "block.minecraft.blue_shulker_box": "Apoti Shulker Bulu",
  "block.minecraft.blue_stained_glass": "Bulu gilasi",
  "block.minecraft.blue_stained_glass_pane": "Bulu gilasi",
  "block.minecraft.blue_terracotta": "Bulu terakota",
  "block.minecraft.blue_wool": "Bulu kìki irun",
  "block.minecraft.bone_block": "Bọnkun Dena",
  "block.minecraft.bookshelf": "Iwe oju",
  "block.minecraft.brain_coral": "Coral Brain",
  "block.minecraft.brain_coral_block": "Ti Nmu Coral Block",
  "block.minecraft.brain_coral_fan": "A fọọmu ti agbada epo",
  "block.minecraft.brain_coral_wall_fan": "Odi ti coefal",
  "block.minecraft.brewing_stand": "Tun",
  "block.minecraft.brick_slab": "Brick awo",
  "block.minecraft.brick_stairs": "Brick Okuta",
  "block.minecraft.brick_wall": "Odi biriki",
  "block.minecraft.bricks": "Biriki",
  "block.minecraft.brown_banner": "Brown Banner",
  "block.minecraft.brown_bed": "Brown Ibusun",
  "block.minecraft.brown_candle": "Burawun Abẹla",
  "block.minecraft.brown_candle_cake": "Akara oyinbo pẹlu Brown abẹla",
  "block.minecraft.brown_carpet": "Orukọ carpeti",
  "block.minecraft.brown_concrete": "Ipara brown",
  "block.minecraft.brown_concrete_powder": "Ipara lulú",
  "block.minecraft.brown_glazed_terracotta": "Terracotta Brown",
  "block.minecraft.brown_mushroom": "Brown Olu",
  "block.minecraft.brown_mushroom_block": "Ilana mycelium",
  "block.minecraft.brown_shulker_box": "Apoti Shulker Brown",
  "block.minecraft.brown_stained_glass": "Orukọ gilasi",
  "block.minecraft.brown_stained_glass_pane": "Orukọ gilasi",
  "block.minecraft.brown_terracotta": "Orukọ terakota",
  "block.minecraft.brown_wool": "Orukọ kìki irun",
  "block.minecraft.bubble_column": "Nkuta Iwe",
  "block.minecraft.bubble_coral": "Okun buba",
  "block.minecraft.bubble_coral_block": "Block ti coral nkuta",
  "block.minecraft.bubble_coral_fan": "A àìpẹ ti iyọ iṣuu",
  "block.minecraft.bubble_coral_wall_fan": "Orilẹ-ọmọ ti o ni ẹba iṣuu",
  "block.minecraft.budding_amethyst": "Budding Amethyst",
  "block.minecraft.bush": "Bush",
  "block.minecraft.cactus": "Ọrọ",
  "block.minecraft.cactus_flower": "Cactus Flower",
  "block.minecraft.cake": "Esufulawa",
  "block.minecraft.calcite": "Calcite",
  "block.minecraft.calibrated_sculk_sensor": "Sensọ Sculk Calibrated",
  "block.minecraft.campfire": "Agbona mejo",
  "block.minecraft.candle": "Abẹla",
  "block.minecraft.candle_cake": "Abẹla Akara Oyinbo",
  "block.minecraft.carrots": "Karooti",
  "block.minecraft.cartography_table": "Atilẹyin Awọn aworan",
  "block.minecraft.carved_pumpkin": "Ti gbe elegede",
  "block.minecraft.cauldron": "Cauldron",
  "block.minecraft.cave_air": "Ile Kaakiri",
  "block.minecraft.cave_vines": "Iho Ajara",
  "block.minecraft.cave_vines_plant": "Iho Ajara Plant",
  "block.minecraft.chain": "Okun",
  "block.minecraft.chain_command_block": "Ṣiṣẹ Ipa Ti Kii",
  "block.minecraft.cherry_button": "Bọtini Àgbálùmo",
  "block.minecraft.cherry_door": "Àgbálùmo ilẹkun",
  "block.minecraft.cherry_fence": "Àgbálùmo Ẹnubodè",
  "block.minecraft.cherry_fence_gate": "Àgbálùmo Ẹnubodè Pada",
  "block.minecraft.cherry_hanging_sign": "Cherry ikele Sign",
  "block.minecraft.cherry_leaves": "Ewe Àgbálùmo",
  "block.minecraft.cherry_log": "Àgbálùmo ẹhin igi",
  "block.minecraft.cherry_planks": "Àgbálùmo igi",
  "block.minecraft.cherry_pressure_plate": "Àgbálùmo Ipa titẹ",
  "block.minecraft.cherry_sapling": "Àgbálùmo ororoo",
  "block.minecraft.cherry_shelf": "Cherry Shelf",
  "block.minecraft.cherry_sign": "Àgbálùmo wọle",
  "block.minecraft.cherry_slab": "Àgbálùmo ami",
  "block.minecraft.cherry_stairs": "Àgbálùmo atẹgun",
  "block.minecraft.cherry_trapdoor": "Àgbálùmo Trapdoor",
  "block.minecraft.cherry_wall_hanging_sign": "Cherry Wall ikele Sign",
  "block.minecraft.cherry_wall_sign": "Cherry Wall Sign",
  "block.minecraft.cherry_wood": "Àgbálùmo igi",
  "block.minecraft.chest": "Àyà",
  "block.minecraft.chipped_anvil": "Bọtini ti a ti bajẹ pupọ",
  "block.minecraft.chiseled_bookshelf": "Chiseled Bookshelf",
  "block.minecraft.chiseled_copper": "Chiseled Copper",
  "block.minecraft.chiseled_deepslate": "Cobbled Deepslate Odi",
  "block.minecraft.chiseled_nether_bricks": "Awọn biriki Nether biriki",
  "block.minecraft.chiseled_polished_blackstone": "Okuta didan ti dudu didan",
  "block.minecraft.chiseled_quartz_block": "Chiseled Quatz Block",
  "block.minecraft.chiseled_red_sandstone": "Gba pupa Iyanrinokuta",
  "block.minecraft.chiseled_resin_bricks": "Chiseled Resin Bricks",
  "block.minecraft.chiseled_sandstone": "Gbe Iyanrinokuta",
  "block.minecraft.chiseled_stone_bricks": "Awọn Bricks Odi Bọtini",
  "block.minecraft.chiseled_tuff": "Chiseled Tuff",
  "block.minecraft.chiseled_tuff_bricks": "Chiseled Tuff Bricks",
  "block.minecraft.chorus_flower": "Egbe Flower",
  "block.minecraft.chorus_plant": "Ọkọ Ikọja",
  "block.minecraft.clay": "Amo",
  "block.minecraft.closed_eyeblossom": "Closed Eyeblossom",
  "block.minecraft.coal_block": "Àkọsílẹ edu",
  "block.minecraft.coal_ore": "Erogba irin",
  "block.minecraft.coarse_dirt": "Aye lile",
  "block.minecraft.cobbled_deepslate": "Awọn Deepslate Cobbled",
  "block.minecraft.cobbled_deepslate_slab": "Cobbled Deepslate Slab",
  "block.minecraft.cobbled_deepslate_stairs": "Cobbled Deepslate pẹtẹẹsì",
  "block.minecraft.cobbled_deepslate_wall": "Cobbled Deepslate Odi",
  "block.minecraft.cobblestone": "Pèpéle",
  "block.minecraft.cobblestone_slab": "Pèpéle gba",
  "block.minecraft.cobblestone_stairs": "Pèpéle atẹgun",
  "block.minecraft.cobblestone_wall": "Odi Cobblestone",
  "block.minecraft.cobweb": "Ibuwọlu",
  "block.minecraft.cocoa": "Koko",
  "block.minecraft.command_block": "Bọtini Ipa",
  "block.minecraft.comparator": "Afiwera Redstone",
  "block.minecraft.composter": "Composter",
  "block.minecraft.conduit": "The asiwaju",
  "block.minecraft.copper_bars": "Copper Bars",
  "block.minecraft.copper_block": "Àkọsílẹ ti Ejò",
  "block.minecraft.copper_bulb": "Copper Bulb",
  "block.minecraft.copper_chain": "Copper Chain",
  "block.minecraft.copper_chest": "Copper Chest",
  "block.minecraft.copper_door": "Copper Door",
  "block.minecraft.copper_golem_statue": "Copper Golem Statue",
  "block.minecraft.copper_grate": "Copper Grate",
  "block.minecraft.copper_lantern": "Copper Lantern",
  "block.minecraft.copper_ore": "Ejò Ejò",
  "block.minecraft.copper_torch": "Copper Torch",
  "block.minecraft.copper_trapdoor": "Copper Trapdoor",
  "block.minecraft.copper_wall_torch": "Copper Wall Torch",
  "block.minecraft.cornflower": "Oka",
  "block.minecraft.cracked_deepslate_bricks": "Awọn biriki Ti a fọ",
  "block.minecraft.cracked_deepslate_tiles": "Awọn Tiles Deepslate Ti Fọ",
  "block.minecraft.cracked_nether_bricks": "Awọn biriki tẹtẹ",
  "block.minecraft.cracked_polished_blackstone_bricks": "Biriki okuta didan dudu pẹlu awọn dojuijako",
  "block.minecraft.cracked_stone_bricks": "Bricks Stone Bricks",
  "block.minecraft.crafter": "Crafter",
  "block.minecraft.crafting_table": "Ipele iṣẹ",
  "block.minecraft.creaking_heart": "Creaking Heart",
  "block.minecraft.creeper_head": "Creeper Orí",
  "block.minecraft.creeper_wall_head": "Ori ori Orilenu",
  "block.minecraft.crimson_button": "Bọtini Crimson",
  "block.minecraft.crimson_door": "Crimson ilekun",
  "block.minecraft.crimson_fence": "Crimson Odi",
  "block.minecraft.crimson_fence_gate": "Crimson Fence Gate",
  "block.minecraft.crimson_fungus": "Crimson Fungus",
  "block.minecraft.crimson_hanging_sign": "Crimson ikele Sign",
  "block.minecraft.crimson_hyphae": "Crimson Hyphae",
  "block.minecraft.crimson_nylium": "Pupa Nylium",
  "block.minecraft.crimson_planks": "Crimson Planks",
  "block.minecraft.crimson_pressure_plate": "Plateson Ipa Plate",
  "block.minecraft.crimson_roots": "Oloogun Roots",
  "block.minecraft.crimson_shelf": "Crimson Shelf",
  "block.minecraft.crimson_sign": "Crimson Ami",
  "block.minecraft.crimson_slab": "Crimson Slab",
  "block.minecraft.crimson_stairs": "Awọn atẹgun Crimson",
  "block.minecraft.crimson_stem": "Crimson Stalk",
  "block.minecraft.crimson_trapdoor": "Crimson Trapdoor",
  "block.minecraft.crimson_wall_hanging_sign": "Crimson Wall ikele Sign",
  "block.minecraft.crimson_wall_sign": "Crimson Wall Ami",
  "block.minecraft.crying_obsidian": "Wiko obsidian",
  "block.minecraft.cut_copper": "Ge Ejò",
  "block.minecraft.cut_copper_slab": "Ge pẹlẹbẹ irin",
  "block.minecraft.cut_copper_stairs": "Ge Ejò pẹtẹẹsì",
  "block.minecraft.cut_red_sandstone": "Ge Igi Ikan-pupa",
  "block.minecraft.cut_red_sandstone_slab": "Ge Okun Iyan-pupa",
  "block.minecraft.cut_sandstone": "Ge Gusu",
  "block.minecraft.cut_sandstone_slab": "Ge Igi Iku-okuta",
  "block.minecraft.cyan_banner": "Banki Cyan",
  "block.minecraft.cyan_bed": "Ibusun Cyan",
  "block.minecraft.cyan_candle": "Alawọ Ewe Bulu Abẹla",
  "block.minecraft.cyan_candle_cake": "Akara oyinbo pẹlu cyan abẹla",
  "block.minecraft.cyan_carpet": "Samawati carpeti",
  "block.minecraft.cyan_concrete": "Ohun-elo Cyan",
  "block.minecraft.cyan_concrete_powder": "Lulú Cyan lulú",
  "block.minecraft.cyan_glazed_terracotta": "Cyan Glazed Terracotta",
  "block.minecraft.cyan_shulker_box": "Apoti Cyan Shulker",
  "block.minecraft.cyan_stained_glass": "Samawati gilasi",
  "block.minecraft.cyan_stained_glass_pane": "Samawati gilasi",
  "block.minecraft.cyan_terracotta": "Samawati terakota",
  "block.minecraft.cyan_wool": "Samawati kìki irun",
  "block.minecraft.damaged_anvil": "Ago ti a ti bajẹ",
  "block.minecraft.dandelion": "Gbìn",
  "block.minecraft.dark_oak_button": "Bọtini lati oaku dudu",
  "block.minecraft.dark_oak_door": "Oaku dudu enu",
  "block.minecraft.dark_oak_fence": "Dudu oaku odi",
  "block.minecraft.dark_oak_fence_gate": "Dudu oaku Ẹnubodè Pada",
  "block.minecraft.dark_oak_hanging_sign": "Dudu Oak ikele Sign",
  "block.minecraft.dark_oak_leaves": "Oaku dudu bunkun",
  "block.minecraft.dark_oak_log": "Oaku Wọle Ojiji",
  "block.minecraft.dark_oak_planks": "Obo igi oaku dudu",
  "block.minecraft.dark_oak_pressure_plate": "Dudu Oaku Ipaba",
  "block.minecraft.dark_oak_sapling": "Ororoo oaku dudu",
  "block.minecraft.dark_oak_shelf": "Dark Oak Shelf",
  "block.minecraft.dark_oak_sign": "Oaku Wọle Ojiji",
  "block.minecraft.dark_oak_slab": "Oaku ti oṣu dudu",
  "block.minecraft.dark_oak_stairs": "Pẹtẹẹsì oaku dudu",
  "block.minecraft.dark_oak_trapdoor": "Oṣuwọn ti oṣu dudu",
  "block.minecraft.dark_oak_wall_hanging_sign": "Dark Oak Wall ikele Sign",
  "block.minecraft.dark_oak_wall_sign": "Odi Odi Odi Titun Wọle",
  "block.minecraft.dark_oak_wood": "Oaku dudu igi",
  "block.minecraft.dark_prismarine": "Prismarine Pudu",
  "block.minecraft.dark_prismarine_slab": "Akara dudu pẹlu prismarine kan",
  "block.minecraft.dark_prismarine_stairs": "Pẹtẹẹsì dudu",
  "block.minecraft.daylight_detector": "Oluwari Oju-ọjọ",
  "block.minecraft.dead_brain_coral": "Brakú ọpọlọ Coral",
  "block.minecraft.dead_brain_coral_block": "Ohun amorindun ti ọpọlọ ikun ti o ku",
  "block.minecraft.dead_brain_coral_fan": "Òkú ọgbẹ àrùn",
  "block.minecraft.dead_brain_coral_wall_fan": "Agbegbe odi ti o ku ti ọra iṣọn",
  "block.minecraft.dead_bubble_coral": "Bkú Bubble Coral",
  "block.minecraft.dead_bubble_coral_block": "Block ti okú nyoju iyun",
  "block.minecraft.dead_bubble_coral_fan": "Afẹfẹ ti o ku ti ẹja iṣan",
  "block.minecraft.dead_bubble_coral_wall_fan": "Agbara odi ti o ku ni adun iṣan",
  "block.minecraft.dead_bush": "Igi ti o gbẹ",
  "block.minecraft.dead_fire_coral": "Coral Fire Coral",
  "block.minecraft.dead_fire_coral_block": "Okun Iku Akanku Iku",
  "block.minecraft.dead_fire_coral_fan": "Okun apanirun ti adun ti ina",
  "block.minecraft.dead_fire_coral_wall_fan": "Agbara odi ti o ku ti adun ina",
  "block.minecraft.dead_horn_coral": "Hornkú Ikun Coral",
  "block.minecraft.dead_horn_coral_block": "Okun Okùn Igbẹ Agbẹ",
  "block.minecraft.dead_horn_coral_fan": "Omi apanirun ti ọra amọ",
  "block.minecraft.dead_horn_coral_wall_fan": "Aja odi ti o ku ti adiye kan",
  "block.minecraft.dead_tube_coral": "Ralkú Ikulu Ikirun",
  "block.minecraft.dead_tube_coral_block": "Block ti coral tubular apo",
  "block.minecraft.dead_tube_coral_fan": "Akan ti o ku ti adiye adiro",
  "block.minecraft.dead_tube_coral_wall_fan": "Aja odi ti o ku ni adun apo",
  "block.minecraft.decorated_pot": "Ikoko ti a ṣe ọṣọ",
  "block.minecraft.deepslate": "Deepslate",
  "block.minecraft.deepslate_brick_slab": "Deepslate Brick Slab",
  "block.minecraft.deepslate_brick_stairs": "Deepslate biriki pẹtẹẹsì",
  "block.minecraft.deepslate_brick_wall": "Deepslate biriki Odi",
  "block.minecraft.deepslate_bricks": "Deepslate Awọn biriki",
  "block.minecraft.deepslate_coal_ore": "Deepslate Oédú Ore",
  "block.minecraft.deepslate_copper_ore": "Deepslate Ejò Ore",
  "block.minecraft.deepslate_diamond_ore": "Deepslate Diamond irin",
  "block.minecraft.deepslate_emerald_ore": "Deepslate Emerald Ore",
  "block.minecraft.deepslate_gold_ore": "Jinna ohun èlò wúrà",
  "block.minecraft.deepslate_iron_ore": "Deepslate Irin irin",
  "block.minecraft.deepslate_lapis_ore": "Deepslate Lapis Lazuli Ore",
  "block.minecraft.deepslate_redstone_ore": "Deepslate Redstone Ore",
  "block.minecraft.deepslate_tile_slab": "Deepslate Tile Slab",
  "block.minecraft.deepslate_tile_stairs": "Deepslate Tile pẹtẹẹsì",
  "block.minecraft.deepslate_tile_wall": "Deepslate Tile Odi",
  "block.minecraft.deepslate_tiles": "Awọn alẹmọ Deepslate",
  "block.minecraft.detector_rail": "Iṣinipopada pẹlu sensọ",
  "block.minecraft.diamond_block": "Àkọsílẹ okuta",
  "block.minecraft.diamond_ore": "Okuta Ẹsọ́",
  "block.minecraft.diorite": "Diorite",
  "block.minecraft.diorite_slab": "Diorite Slab",
  "block.minecraft.diorite_stairs": "Diorite pẹtẹẹsì",
  "block.minecraft.diorite_wall": "Diorite Wall",
  "block.minecraft.dirt": "Aiye",
  "block.minecraft.dirt_path": "Dọti Ona",
  "block.minecraft.dispenser": "Atokan",
  "block.minecraft.dragon_egg": "Dragon Ẹyin",
  "block.minecraft.dragon_head": "Dragoni Orí",
  "block.minecraft.dragon_wall_head": "Oriiran Odi Oga",
  "block.minecraft.dried_ghast": "Dried Ghast",
  "block.minecraft.dried_kelp_block": "Ti gbin Kelp Block",
  "block.minecraft.dripstone_block": "Ohun Amorindun",
  "block.minecraft.dropper": "Ọgbẹ",
  "block.minecraft.emerald_block": "Àkọsílẹ Ti Emerald",
  "block.minecraft.emerald_ore": "Emerald Ore",
  "block.minecraft.enchanting_table": "Tọpeli tabili",
  "block.minecraft.end_gateway": "Ipade ipari",
  "block.minecraft.end_portal": "Ipari Portal",
  "block.minecraft.end_portal_frame": "Eto Ilana End Portal",
  "block.minecraft.end_rod": "Oṣiṣẹ ipari",
  "block.minecraft.end_stone": "Opin Okuta",
  "block.minecraft.end_stone_brick_slab": "Opin Brick Stone",
  "block.minecraft.end_stone_brick_stairs": "Opin Brick Stone Stone",
  "block.minecraft.end_stone_brick_wall": "Pari Odi Brick Stone",
  "block.minecraft.end_stone_bricks": "Ipari Awọn biriki Stone",
  "block.minecraft.ender_chest": "Ender Ọpa",
  "block.minecraft.exposed_chiseled_copper": "Exposed Chiseled Copper",
  "block.minecraft.exposed_copper": "Ejò Ti A Fi Han",
  "block.minecraft.exposed_copper_bars": "Exposed Copper Bars",
  "block.minecraft.exposed_copper_bulb": "Exposed Copper Bulb",
  "block.minecraft.exposed_copper_chain": "Exposed Copper Chain",
  "block.minecraft.exposed_copper_chest": "Exposed Copper Chest",
  "block.minecraft.exposed_copper_door": "Exposed Copper Door",
  "block.minecraft.exposed_copper_golem_statue": "Exposed Copper Golem Statue",
  "block.minecraft.exposed_copper_grate": "Exposed Copper Grate",
  "block.minecraft.exposed_copper_lantern": "Exposed Copper Lantern",
  "block.minecraft.exposed_copper_trapdoor": "Exposed Copper Trapdoor",
  "block.minecraft.exposed_cut_copper": "Ifihan Ge Ejò",
  "block.minecraft.exposed_cut_copper_slab": "Ifihan Ge Ejò Slab",
  "block.minecraft.exposed_cut_copper_stairs": "Ṣe afihan awọn pẹtẹẹsì idẹ",
  "block.minecraft.exposed_lightning_rod": "Exposed Lightning Rod",
  "block.minecraft.farmland": "Aaye ti a gbin",
  "block.minecraft.fern": "Ewedò wẹ̀wẹ̀",
  "block.minecraft.fire": "Ina",
  "block.minecraft.fire_coral": "Epo adan",
  "block.minecraft.fire_coral_block": "Igbẹ Aṣọ Ina",
  "block.minecraft.fire_coral_fan": "A fọọmu ti erun igbona",
  "block.minecraft.fire_coral_wall_fan": "Odi ti erun ina",
  "block.minecraft.firefly_bush": "Firefly Bush",
  "block.minecraft.fletching_table": "Fletching Table",
  "block.minecraft.flower_pot": "Ikoko Adodo",
  "block.minecraft.flowering_azalea": "Aladodo Azalea",
  "block.minecraft.flowering_azalea_leaves": "Aladodo Azalea ewé",
  "block.minecraft.frogspawn": "Frogspawn",
  "block.minecraft.frosted_ice": "Tutu yinyin",
  "block.minecraft.furnace": "Beki",
  "block.minecraft.gilded_blackstone": "Okuta dudu dudu",
  "block.minecraft.glass": "Gilasi",
  "block.minecraft.glass_pane": "Gilasi",
  "block.minecraft.glow_lichen": "Glow Lichen",
  "block.minecraft.glowstone": "Imọlẹ okuta",
  "block.minecraft.gold_block": "Iwọn Goolu",
  "block.minecraft.gold_ore": "Ohun irin goolu",
  "block.minecraft.golden_dandelion": "Golden Dandelion",
  "block.minecraft.granite": "Giranaiti",
  "block.minecraft.granite_slab": "Granite Slab",
  "block.minecraft.granite_stairs": "Granite Awọn atẹgun",
  "block.minecraft.granite_wall": "Granite arabara",
  "block.minecraft.grass": "Koriko",
  "block.minecraft.grass_block": "Dii koriko",
  "block.minecraft.gravel": "Wẹwẹ",
  "block.minecraft.gray_banner": "Banki Grey",
  "block.minecraft.gray_bed": "Grẹy Ibusun",
  "block.minecraft.gray_candle": "Grẹy Abẹla",
  "block.minecraft.gray_candle_cake": "Akara oyinbo pẹlu grẹy abẹla",
  "block.minecraft.gray_carpet": "Grẹy carpeti",
  "block.minecraft.gray_concrete": "Grey nja",
  "block.minecraft.gray_concrete_powder": "Grey nja lulú",
  "block.minecraft.gray_glazed_terracotta": "Grey Glazed Terracotta",
  "block.minecraft.gray_shulker_box": "Apoti Shulker Grey",
  "block.minecraft.gray_stained_glass": "Grẹy gilasi",
  "block.minecraft.gray_stained_glass_pane": "Grẹy gilasi",
  "block.minecraft.gray_terracotta": "Grẹy terakota",
  "block.minecraft.gray_wool": "Grẹy kìki irun",
  "block.minecraft.green_banner": "Banner Green",
  "block.minecraft.green_bed": "Alawọ Ewe Ibusun",
  "block.minecraft.green_candle": "Alawọ ewe Abẹla",
  "block.minecraft.green_candle_cake": "Akara oyinbo pẹlu alawọ ewe abẹla",
  "block.minecraft.green_carpet": "Aipọn carpeti",
  "block.minecraft.green_concrete": "Alawọ ewe alawọ ewe",
  "block.minecraft.green_concrete_powder": "Lulú nja alawọ",
  "block.minecraft.green_glazed_terracotta": "Alawọ ewe Glazed Terracotta",
  "block.minecraft.green_shulker_box": "Apoti Shulker Green",
  "block.minecraft.green_stained_glass": "Aipọn gilasi",
  "block.minecraft.green_stained_glass_pane": "Aipọn gilasi",
  "block.minecraft.green_terracotta": "Aipọn terakota",
  "block.minecraft.green_wool": "Aipọn kìki irun",
  "block.minecraft.grindstone": "Oṣuwọn eefun",
  "block.minecraft.hanging_roots": "Awọn gbongbo Adiye",
  "block.minecraft.hay_block": "Igi ti koriko",
  "block.minecraft.heavy_core": "Heavy Core",
  "block.minecraft.heavy_weighted_pressure_plate": "Iwọn ipilẹ ti o ni irọra pípẹ",
  "block.minecraft.honey_block": "Dẹkun Ẹnu",
  "block.minecraft.honeycomb_block": "Dina ohun amorindun",
  "block.minecraft.hopper": "Hopper",
  "block.minecraft.horn_coral": "Coral ti a mu",
  "block.minecraft.horn_coral_block": "Ti Nmu Coral Block",
  "block.minecraft.horn_coral_fan": "A àìpẹ ti adiye aman",
  "block.minecraft.horn_coral_wall_fan": "Orilẹ-ibọn ti ọra iṣan",
  "block.minecraft.ice": "Yinyin",
  "block.minecraft.infested_chiseled_stone_bricks": "Biriki okuta ti a fi oju ṣe",
  "block.minecraft.infested_cobblestone": "Ti fi kún pèpéle",
  "block.minecraft.infested_cracked_stone_bricks": "Biriki okuta ti a ti fi okuta ṣubu",
  "block.minecraft.infested_deepslate": "Awọn ẹlẹsẹ ti o ni ipalara",
  "block.minecraft.infested_mossy_stone_bricks": "Biriki ti a fi okuta pa ti a da",
  "block.minecraft.infested_stone": "Okuta ti a da",
  "block.minecraft.infested_stone_bricks": "Biriki okuta ti a ti fi ẹ si",
  "block.minecraft.iron_bars": "Iron Bars",
  "block.minecraft.iron_block": "Iwọn Iron",
  "block.minecraft.iron_chain": "Iron Chain",
  "block.minecraft.iron_door": "Iron enu",
  "block.minecraft.iron_ore": "Iron Ẹsọ́",
  "block.minecraft.iron_trapdoor": "Gbigbọn irín",
  "block.minecraft.jack_o_lantern": "Jack o'Lantern",
  "block.minecraft.jigsaw": "Jigsaw Àkọsílẹ",
  "block.minecraft.jukebox": "Aṣọ ti ndun",
  "block.minecraft.jungle_button": "Bọtini Jungle",
  "block.minecraft.jungle_door": "Jungle enu",
  "block.minecraft.jungle_fence": "Jungle odi",
  "block.minecraft.jungle_fence_gate": "Jungle Ẹnubodè Pada",
  "block.minecraft.jungle_hanging_sign": "Ibugbe adiye Igbo",
  "block.minecraft.jungle_leaves": "Jungle bunkun",
  "block.minecraft.jungle_log": "Jungle Wọle",
  "block.minecraft.jungle_planks": "Ile-iṣẹ igbo",
  "block.minecraft.jungle_pressure_plate": "Ikọju Igi Ilu",
  "block.minecraft.jungle_sapling": "Ororoo igboro",
  "block.minecraft.jungle_shelf": "Jungle Shelf",
  "block.minecraft.jungle_sign": "Ipele igbo",
  "block.minecraft.jungle_slab": "Ipele igbo",
  "block.minecraft.jungle_stairs": "Atẹgun igbo",
  "block.minecraft.jungle_trapdoor": "Jungle niyeon",
  "block.minecraft.jungle_wall_hanging_sign": "Igbo odi ikele Sign",
  "block.minecraft.jungle_wall_sign": "Odi Igi Jungle",
  "block.minecraft.jungle_wood": "Jungle igi",
  "block.minecraft.kelp": "Kelp",
  "block.minecraft.kelp_plant": "Ohun ọṣọ Ẹrọ",
  "block.minecraft.ladder": "Akaba",
  "block.minecraft.lantern": "Atupa",
  "block.minecraft.lapis_block": "Àkọsílẹ ti Lapis Lazuli",
  "block.minecraft.lapis_ore": "Lapis Lazuli Ẹsọ́",
  "block.minecraft.large_amethyst_bud": "Amethyst Egbon Nla",
  "block.minecraft.large_fern": "Nla ewedò wẹ̀wẹ̀",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Igbomikana omi",
  "block.minecraft.leaf_litter": "Leaf Litter",
  "block.minecraft.lectern": "Lectern",
  "block.minecraft.lever": "Lefa",
  "block.minecraft.light": "Imọlẹ",
  "block.minecraft.light_blue_banner": "Imọlẹ Blue Banner",
  "block.minecraft.light_blue_bed": "Ibusun Bulu ti o ni ina",
  "block.minecraft.light_blue_candle": "Bulu Didan Abẹla",
  "block.minecraft.light_blue_candle_cake": "Akara oyinbo pẹlu abẹla Imọlẹ Bulu",
  "block.minecraft.light_blue_carpet": "Imọlẹ bulu carpeti",
  "block.minecraft.light_blue_concrete": "Light bulu Nkan",
  "block.minecraft.light_blue_concrete_powder": "Pulu lulú Light bulu",
  "block.minecraft.light_blue_glazed_terracotta": "Light Blue Glazed Terracotta",
  "block.minecraft.light_blue_shulker_box": "Apoti Shulker Light",
  "block.minecraft.light_blue_stained_glass": "Imọlẹ bulu gilasi",
  "block.minecraft.light_blue_stained_glass_pane": "Imọlẹ bulu gilasi",
  "block.minecraft.light_blue_terracotta": "Imọlẹ bulu terakota",
  "block.minecraft.light_blue_wool": "Imọlẹ bulu kìki irun",
  "block.minecraft.light_gray_banner": "Imọlẹ Grey Light",
  "block.minecraft.light_gray_bed": "Ibusun Grẹy",
  "block.minecraft.light_gray_candle": "Bulu ina Abẹla",
  "block.minecraft.light_gray_candle_cake": "Akara oyinbo pẹlu Grẹy Imọlẹ abẹla",
  "block.minecraft.light_gray_carpet": "Imọlẹ grẹy carpeti",
  "block.minecraft.light_gray_concrete": "Imọlẹ Grey Light",
  "block.minecraft.light_gray_concrete_powder": "Ina grẹy nja lulú",
  "block.minecraft.light_gray_glazed_terracotta": "Light Grey Glazed Terracotta",
  "block.minecraft.light_gray_shulker_box": "Apoti Imọlẹ Grey Shulker",
  "block.minecraft.light_gray_stained_glass": "Imọlẹ grẹy gilasi",
  "block.minecraft.light_gray_stained_glass_pane": "Imọlẹ grẹy gilasi",
  "block.minecraft.light_gray_terracotta": "Imọlẹ grẹy terakota",
  "block.minecraft.light_gray_wool": "Imọlẹ grẹy kìki irun",
  "block.minecraft.light_weighted_pressure_plate": "Iwọn Pilasi Oye",
  "block.minecraft.lightning_rod": "Opa Itanna",
  "block.minecraft.lilac": "Lai",
  "block.minecraft.lily_of_the_valley": "Lily ti afonifoji",
  "block.minecraft.lily_pad": "Lily Paadi",
  "block.minecraft.lime_banner": "Asia orombo",
  "block.minecraft.lime_bed": "Orombo Wewe",
  "block.minecraft.lime_candle": "Orombo Wewe Abẹla",
  "block.minecraft.lime_candle_cake": "Akara oyinbo pẹlu orombo abẹla",
  "block.minecraft.lime_carpet": "Imọlẹ carpeti",
  "block.minecraft.lime_concrete": "Orombo to konge",
  "block.minecraft.lime_concrete_powder": "Orombo wewe lulú",
  "block.minecraft.lime_glazed_terracotta": "Orombo wewe Glazed Terracotta",
  "block.minecraft.lime_shulker_box": "Orombo wewe apoti",
  "block.minecraft.lime_stained_glass": "Imọlẹ aipọn gilasi",
  "block.minecraft.lime_stained_glass_pane": "Imọlẹ aipọn gilasi",
  "block.minecraft.lime_terracotta": "Imọlẹ terakota",
  "block.minecraft.lime_wool": "Imọlẹ kìki irun",
  "block.minecraft.lodestone": "Oofa",
  "block.minecraft.loom": "Loom",
  "block.minecraft.magenta_banner": "Asia Banner",
  "block.minecraft.magenta_bed": "Magenta Ibusun",
  "block.minecraft.magenta_candle": "Magenta Abẹla",
  "block.minecraft.magenta_candle_cake": "Akara oyinbo pẹlu Magenta abẹla",
  "block.minecraft.magenta_carpet": "Crimson carpeti",
  "block.minecraft.magenta_concrete": "Ohun-ọṣọ Magenta",
  "block.minecraft.magenta_concrete_powder": "Magenta ṣoki lulú",
  "block.minecraft.magenta_glazed_terracotta": "Magenta Glazed Terracotta",
  "block.minecraft.magenta_shulker_box": "Apoti Magenta Shulker",
  "block.minecraft.magenta_stained_glass": "Crimson gilasi",
  "block.minecraft.magenta_stained_glass_pane": "Àwo-pupayò gilasi",
  "block.minecraft.magenta_terracotta": "Crimson terakota",
  "block.minecraft.magenta_wool": "Crimson kìki irun",
  "block.minecraft.magma_block": "Dẹkun Magma",
  "block.minecraft.mangrove_button": "Bọtini Mangrove",
  "block.minecraft.mangrove_door": "Ilekun Mangrove",
  "block.minecraft.mangrove_fence": "Mangrove odi",
  "block.minecraft.mangrove_fence_gate": "Mangrove odi Gate",
  "block.minecraft.mangrove_hanging_sign": "Mangrove ikele Sign",
  "block.minecraft.mangrove_leaves": "Awọn ewe Mangrove",
  "block.minecraft.mangrove_log": "Mangrove Wọle",
  "block.minecraft.mangrove_planks": "Mangrove Planks",
  "block.minecraft.mangrove_pressure_plate": "Mangrove Ipa Awo",
  "block.minecraft.mangrove_propagule": "Mangrove Propagule",
  "block.minecraft.mangrove_roots": "Awọn gbongbo Mangrove",
  "block.minecraft.mangrove_shelf": "Mangrove Shelf",
  "block.minecraft.mangrove_sign": "Mangrove Sign",
  "block.minecraft.mangrove_slab": "Mangrove pẹlẹbẹ",
  "block.minecraft.mangrove_stairs": "Mangrove pẹtẹẹsì",
  "block.minecraft.mangrove_trapdoor": "Mangrove Trapdoor",
  "block.minecraft.mangrove_wall_hanging_sign": "Mangrove Wall ikele Sign",
  "block.minecraft.mangrove_wall_sign": "Mangrove Wall Sign",
  "block.minecraft.mangrove_wood": "Igi mangrove",
  "block.minecraft.medium_amethyst_bud": "Alabọde Amethyst Egbọn",
  "block.minecraft.melon": "Melon",
  "block.minecraft.melon_stem": "Melon Tita",
  "block.minecraft.moss_block": "Iboju Moss",
  "block.minecraft.moss_carpet": "Moss Kapeti",
  "block.minecraft.mossy_cobblestone": "A apẹrẹ paati",
  "block.minecraft.mossy_cobblestone_slab": "Mossy Cobblestone Slab",
  "block.minecraft.mossy_cobblestone_stairs": "Mossy Cobblestone Awọn atẹgun",
  "block.minecraft.mossy_cobblestone_wall": "Mossy Cobblestone Odi",
  "block.minecraft.mossy_stone_brick_slab": "A apẹrẹ okuta biriki",
  "block.minecraft.mossy_stone_brick_stairs": "Mossy Stone Brick Stairs",
  "block.minecraft.mossy_stone_brick_wall": "Mossy Stone Brick Wall",
  "block.minecraft.mossy_stone_bricks": "A apẹrẹ okuta biriki",
  "block.minecraft.moving_piston": "Gbigbe pisitini",
  "block.minecraft.mud": "Pẹtẹpẹtẹ",
  "block.minecraft.mud_brick_slab": "Pẹtẹpẹtẹ Biriki pẹlẹbẹ",
  "block.minecraft.mud_brick_stairs": "Pẹtẹpẹtẹ biriki pẹtẹẹsì",
  "block.minecraft.mud_brick_wall": "Pẹtẹpẹtẹ biriki Wall",
  "block.minecraft.mud_bricks": "Awọn biriki pẹtẹpẹtẹ",
  "block.minecraft.muddy_mangrove_roots": "Muddy Mangrove wá",
  "block.minecraft.mushroom_stem": "Egbin je",
  "block.minecraft.mycelium": "Mycelium",
  "block.minecraft.nether_brick_fence": "Nether Brick Fence",
  "block.minecraft.nether_brick_slab": "Nether biriki gbu",
  "block.minecraft.nether_brick_stairs": "Nether Brick Okuta",
  "block.minecraft.nether_brick_wall": "Apaadi apadi",
  "block.minecraft.nether_bricks": "Nether biriki",
  "block.minecraft.nether_gold_ore": "Nether Ore Gold",
  "block.minecraft.nether_portal": "Lapapọ Èbúté",
  "block.minecraft.nether_quartz_ore": "Nether Quatz Ore",
  "block.minecraft.nether_sprouts": "Awọn Sprouts Netherlands",
  "block.minecraft.nether_wart": "Nether Wart",
  "block.minecraft.nether_wart_block": "Dẹkun Nether Wart",
  "block.minecraft.netherite_block": "Dẹkun Netherite",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Àkọsílẹ dun",
  "block.minecraft.oak_button": "Bọtini Oaku",
  "block.minecraft.oak_door": "Oaku enu",
  "block.minecraft.oak_fence": "Oaku odi",
  "block.minecraft.oak_fence_gate": "Oaku Ẹnubodè Pada",
  "block.minecraft.oak_hanging_sign": "Oak ikele Sign",
  "block.minecraft.oak_leaves": "Oaku bunkun",
  "block.minecraft.oak_log": "Oka Wọle",
  "block.minecraft.oak_planks": "Igi oaku",
  "block.minecraft.oak_pressure_plate": "Atilẹyin Itoju Oaku",
  "block.minecraft.oak_sapling": "Ororoo oaku",
  "block.minecraft.oak_shelf": "Oak Shelf",
  "block.minecraft.oak_sign": "Aami ọṣọ",
  "block.minecraft.oak_slab": "Oaku awo",
  "block.minecraft.oak_stairs": "Pẹtẹẹsì oke",
  "block.minecraft.oak_trapdoor": "Oak oṣuwọn",
  "block.minecraft.oak_wall_hanging_sign": "Oak Wall ikele Sign",
  "block.minecraft.oak_wall_sign": "Odi Wall Sign",
  "block.minecraft.oak_wood": "Oaku igi",
  "block.minecraft.observer": "Oluwoye",
  "block.minecraft.obsidian": "Ojuju",
  "block.minecraft.ochre_froglight": "Ocher Froglight",
  "block.minecraft.ominous_banner": "Asia Ominous",
  "block.minecraft.open_eyeblossom": "Open Eyeblossom",
  "block.minecraft.orange_banner": "Asia asia",
  "block.minecraft.orange_bed": "Osan Ibusun",
  "block.minecraft.orange_candle": "Ọsan Abẹla",
  "block.minecraft.orange_candle_cake": "Akara oyinbo pẹlu Okan abẹla Orange",
  "block.minecraft.orange_carpet": "Osan carpeti",
  "block.minecraft.orange_concrete": "Orange Nkan",
  "block.minecraft.orange_concrete_powder": "Orange nipon lulú",
  "block.minecraft.orange_glazed_terracotta": "Osan Glazed Terracotta",
  "block.minecraft.orange_shulker_box": "Apoti Shulker Orange",
  "block.minecraft.orange_stained_glass": "Osan gilasi",
  "block.minecraft.orange_stained_glass_pane": "Osan gilasi",
  "block.minecraft.orange_terracotta": "Osan terakota",
  "block.minecraft.orange_tulip": "Osan tulip",
  "block.minecraft.orange_wool": "Osan kìki irun",
  "block.minecraft.oxeye_daisy": "Aṣiṣe",
  "block.minecraft.oxidized_chiseled_copper": "Oxidized Chiseled Copper",
  "block.minecraft.oxidized_copper": "Ejò Oniduro",
  "block.minecraft.oxidized_copper_bars": "Oxidized Copper Bars",
  "block.minecraft.oxidized_copper_bulb": "Oxidized Copper Bulb",
  "block.minecraft.oxidized_copper_chain": "Oxidized Copper Chain",
  "block.minecraft.oxidized_copper_chest": "Oxidized Copper Chest",
  "block.minecraft.oxidized_copper_door": "Oxidized Copper Door",
  "block.minecraft.oxidized_copper_golem_statue": "Oxidized Copper Golem Statue",
  "block.minecraft.oxidized_copper_grate": "Oxidized Copper Grate",
  "block.minecraft.oxidized_copper_lantern": "Oxidized Copper Lantern",
  "block.minecraft.oxidized_copper_trapdoor": "Oxidized Copper Trapdoor",
  "block.minecraft.oxidized_cut_copper": "Oxidized Ge Ejò",
  "block.minecraft.oxidized_cut_copper_slab": "Oxidized Ge Ejò Slab",
  "block.minecraft.oxidized_cut_copper_stairs": "Oxidized Ge Ejò pẹtẹẹsì",
  "block.minecraft.oxidized_lightning_rod": "Oxidized Lightning Rod",
  "block.minecraft.packed_ice": "Iwapọ yinyin",
  "block.minecraft.packed_mud": "Papọ Pẹtẹpẹtẹ",
  "block.minecraft.pale_hanging_moss": "Pale Hanging Moss",
  "block.minecraft.pale_moss_block": "Pale Moss Block",
  "block.minecraft.pale_moss_carpet": "Pale Moss Carpet",
  "block.minecraft.pale_oak_button": "Pale Oak Button",
  "block.minecraft.pale_oak_door": "Pale Oak Door",
  "block.minecraft.pale_oak_fence": "Pale Oak Fence",
  "block.minecraft.pale_oak_fence_gate": "Pale Oak Fence Gate",
  "block.minecraft.pale_oak_hanging_sign": "Pale Oak Hanging Sign",
  "block.minecraft.pale_oak_leaves": "Pale Oak Leaves",
  "block.minecraft.pale_oak_log": "Pale Oak Log",
  "block.minecraft.pale_oak_planks": "Pale Oak Planks",
  "block.minecraft.pale_oak_pressure_plate": "Pale Oak Pressure Plate",
  "block.minecraft.pale_oak_sapling": "Pale Oak Sapling",
  "block.minecraft.pale_oak_shelf": "Pale Oak Shelf",
  "block.minecraft.pale_oak_sign": "Pale Oak Sign",
  "block.minecraft.pale_oak_slab": "Pale Oak Slab",
  "block.minecraft.pale_oak_stairs": "Pale Oak Stairs",
  "block.minecraft.pale_oak_trapdoor": "Pale Oak Trapdoor",
  "block.minecraft.pale_oak_wall_hanging_sign": "Pale Oak Wall Hanging Sign",
  "block.minecraft.pale_oak_wall_sign": "Pale Oak Wall Sign",
  "block.minecraft.pale_oak_wood": "Pale Oak Wood",
  "block.minecraft.pearlescent_froglight": "Pearlescent Froglight",
  "block.minecraft.peony": "Peonia",
  "block.minecraft.petrified_oak_slab": "Oaku igi oaku ti o ti gbilẹ",
  "block.minecraft.piglin_head": "Piglin ori",
  "block.minecraft.piglin_wall_head": "Piglin odi ori",
  "block.minecraft.pink_banner": "Asia Pink",
  "block.minecraft.pink_bed": "Pink Ibusun",
  "block.minecraft.pink_candle": "Pink Abẹla",
  "block.minecraft.pink_candle_cake": "Akara oyinbo pẹlu pink abẹla",
  "block.minecraft.pink_carpet": "Òdòdó carpeti",
  "block.minecraft.pink_concrete": "Alawọ ewe Pink",
  "block.minecraft.pink_concrete_powder": "Pupa fẹẹrẹ lulú",
  "block.minecraft.pink_glazed_terracotta": "Pink Glazed Terracotta",
  "block.minecraft.pink_petals": "Pink Petals",
  "block.minecraft.pink_shulker_box": "Apoti Shulker Pink",
  "block.minecraft.pink_stained_glass": "Òdòdó gilasi",
  "block.minecraft.pink_stained_glass_pane": "Òdòdó gilasi",
  "block.minecraft.pink_terracotta": "Òdòdó terakota",
  "block.minecraft.pink_tulip": "Òdòdó tulip",
  "block.minecraft.pink_wool": "Òdòdó kìki irun",
  "block.minecraft.piston": "Piston",
  "block.minecraft.piston_head": "Pisitini ori",
  "block.minecraft.pitcher_crop": "Pitcher Irugbin",
  "block.minecraft.pitcher_plant": "Pitcher ọgbin",
  "block.minecraft.player_head": "Olusakoso akọ",
  "block.minecraft.player_head.named": "%s's Orí",
  "block.minecraft.player_wall_head": "Ori-ori Ẹrọ-ẹrọ",
  "block.minecraft.podzol": "Alaadun",
  "block.minecraft.pointed_dripstone": "Spiky drip",
  "block.minecraft.polished_andesite": "Pólándì andesite",
  "block.minecraft.polished_andesite_slab": "Agbara Andesite ti a gbin",
  "block.minecraft.polished_andesite_stairs": "Atẹgun Andesite ti a da didan",
  "block.minecraft.polished_basalt": "Basalt didan",
  "block.minecraft.polished_blackstone": "Okuta dudu ti a ni didan",
  "block.minecraft.polished_blackstone_brick_slab": "Okuta dudu biriki Slab",
  "block.minecraft.polished_blackstone_brick_stairs": "Dudu okuta didan biriki",
  "block.minecraft.polished_blackstone_brick_wall": "Odi Okuta biriki dudu",
  "block.minecraft.polished_blackstone_bricks": "Awọn okuta biriki Didan Didan",
  "block.minecraft.polished_blackstone_button": "Bọtini Okuta Okuta dudu",
  "block.minecraft.polished_blackstone_pressure_plate": "Awo didan Stone Ipa",
  "block.minecraft.polished_blackstone_slab": "Didan Stone Stone",
  "block.minecraft.polished_blackstone_stairs": "Odi okuta okuta didan dudu",
  "block.minecraft.polished_blackstone_wall": "Odi Okuta Odi dudu",
  "block.minecraft.polished_deepslate": "Awọn awoṣe didan",
  "block.minecraft.polished_deepslate_slab": "Didan Deepslate Slab",
  "block.minecraft.polished_deepslate_stairs": "Awọn pẹtẹẹsẹ Deeplate didan",
  "block.minecraft.polished_deepslate_wall": "Didan Deepslate Odi",
  "block.minecraft.polished_diorite": "Pólándì diorite",
  "block.minecraft.polished_diorite_slab": "Agbara Diorite Polished",
  "block.minecraft.polished_diorite_stairs": "Awọn Diorite Poli ti o ni ẹgẹ",
  "block.minecraft.polished_granite": "Pólándì giranaiti",
  "block.minecraft.polished_granite_slab": "Awọn Ẹlẹdẹ Granite Slab",
  "block.minecraft.polished_granite_stairs": "Awọn Igunna polished Granite",
  "block.minecraft.polished_tuff": "Polished Tuff",
  "block.minecraft.polished_tuff_slab": "Polished Tuff Slab",
  "block.minecraft.polished_tuff_stairs": "Polished Tuff Stairs",
  "block.minecraft.polished_tuff_wall": "Polished Tuff Wall",
  "block.minecraft.poppy": "Irugbin",
  "block.minecraft.potatoes": "Poteto",
  "block.minecraft.potted_acacia_sapling": "Igi Acacia Oro",
  "block.minecraft.potted_allium": "Ti mu Allium",
  "block.minecraft.potted_azalea_bush": "Potted Azalea",
  "block.minecraft.potted_azure_bluet": "Ti mu Azure Bluet",
  "block.minecraft.potted_bamboo": "Ose Bamboo",
  "block.minecraft.potted_birch_sapling": "Igi Birch Oro",
  "block.minecraft.potted_blue_orchid": "Ti mu bulu Orchid",
  "block.minecraft.potted_brown_mushroom": "Ti mu olu pupa",
  "block.minecraft.potted_cactus": "Kaadi ti o ti gbe",
  "block.minecraft.potted_cherry_sapling": "Igi ṣẹẹri Oro",
  "block.minecraft.potted_closed_eyeblossom": "Potted Closed Eyeblossom",
  "block.minecraft.potted_cornflower": "Potted Cornflower",
  "block.minecraft.potted_crimson_fungus": "Potted Crimson Fungus",
  "block.minecraft.potted_crimson_roots": "Gbongbo Pupa ni Ikoko",
  "block.minecraft.potted_dandelion": "Ti mu Dandelion",
  "block.minecraft.potted_dark_oak_sapling": "Igi Oaku dudu Oro",
  "block.minecraft.potted_dead_bush": "Okun Igbẹ Pupa",
  "block.minecraft.potted_fern": "Ti mu ewedò wẹ̀wẹ̀",
  "block.minecraft.potted_flowering_azalea_bush": "Potoko Aladodo Azalea",
  "block.minecraft.potted_golden_dandelion": "Potted Golden Dandelion",
  "block.minecraft.potted_jungle_sapling": "Igi Jungle Oro",
  "block.minecraft.potted_lily_of_the_valley": "Lily Potted ti afonifoji",
  "block.minecraft.potted_mangrove_propagule": "Potted Mangrove Propagule",
  "block.minecraft.potted_oak_sapling": "Igi Oaku Oro",
  "block.minecraft.potted_open_eyeblossom": "Potted Open Eyeblossom",
  "block.minecraft.potted_orange_tulip": "Ti mu ọsan Tulip",
  "block.minecraft.potted_oxeye_daisy": "Ti mu Oxeye Daisy",
  "block.minecraft.potted_pale_oak_sapling": "Potted Pale Oak Sapling",
  "block.minecraft.potted_pink_tulip": "Ti mu Pink Tulip",
  "block.minecraft.potted_poppy": "Ti mu Poppy",
  "block.minecraft.potted_red_mushroom": "Ti mu olu pupa",
  "block.minecraft.potted_red_tulip": "Ti mu Red Tulip",
  "block.minecraft.potted_spruce_sapling": "Igi Spruce Oro",
  "block.minecraft.potted_torchflower": "Potted Torchflower",
  "block.minecraft.potted_warped_fungus": "Potted Warung Fungus",
  "block.minecraft.potted_warped_roots": "Awọn gbongbo ti a fọ",
  "block.minecraft.potted_white_tulip": "Ti mu funfun Tulip",
  "block.minecraft.potted_wither_rose": "Weded Wither Soke",
  "block.minecraft.powder_snow": "Powder Snow",
  "block.minecraft.powder_snow_cauldron": "Lulú Egbon Cauldron",
  "block.minecraft.powered_rail": "Agbara iṣinipopada",
  "block.minecraft.prismarine": "Prismarine",
  "block.minecraft.prismarine_brick_slab": "Brick awo pẹlu prismarine",
  "block.minecraft.prismarine_brick_stairs": "Prismarine brick atẹgun",
  "block.minecraft.prismarine_bricks": "Awọn ohun amorindun Prismarine",
  "block.minecraft.prismarine_slab": "Plate pẹlu prismarine",
  "block.minecraft.prismarine_stairs": "Prismarine atẹgun",
  "block.minecraft.prismarine_wall": "Ile Prismarine",
  "block.minecraft.pumpkin": "Elegede",
  "block.minecraft.pumpkin_stem": "Elegede tita",
  "block.minecraft.purple_banner": "Asia asia",
  "block.minecraft.purple_bed": "Ibusun Eleyi ti",
  "block.minecraft.purple_candle": "Eleyi ti Abẹla",
  "block.minecraft.purple_candle_cake": "Akara oyinbo pẹlu Eleyi ti abẹla",
  "block.minecraft.purple_carpet": "Àluko carpeti",
  "block.minecraft.purple_concrete": "Nkankan Alamọ",
  "block.minecraft.purple_concrete_powder": "Pululu konge lulú",
  "block.minecraft.purple_glazed_terracotta": "Eleyi ti Glazed Terracotta",
  "block.minecraft.purple_shulker_box": "Apoti Shulker Apo",
  "block.minecraft.purple_stained_glass": "Àluko gilasi",
  "block.minecraft.purple_stained_glass_pane": "Àluko gilasi",
  "block.minecraft.purple_terracotta": "Àluko terakota",
  "block.minecraft.purple_wool": "Àluko kìki irun",
  "block.minecraft.purpur_block": "Purpur Block",
  "block.minecraft.purpur_pillar": "Purpur Pillar",
  "block.minecraft.purpur_slab": "elese pẹlẹbẹ",
  "block.minecraft.purpur_stairs": "Awọn pẹtẹẹsẹ Purpur",
  "block.minecraft.quartz_block": "Block Of Quartz",
  "block.minecraft.quartz_bricks": "Awọn biriki Quartz",
  "block.minecraft.quartz_pillar": "Ẹrọ Quartz",
  "block.minecraft.quartz_slab": "Kuotisi gbu",
  "block.minecraft.quartz_stairs": "Quartet Awọn atẹgun",
  "block.minecraft.rail": "Iṣinipopada",
  "block.minecraft.raw_copper_block": "Àkọsílẹ ti Raw Ejò",
  "block.minecraft.raw_gold_block": "Àkọsílẹ ti Raw Raw",
  "block.minecraft.raw_iron_block": "Àkọsílẹ ti Raw Iron",
  "block.minecraft.red_banner": "Asia Pupa",
  "block.minecraft.red_bed": "Pupa Ibusun",
  "block.minecraft.red_candle": "Pupa Abẹla",
  "block.minecraft.red_candle_cake": "Akara oyinbo pẹlu pupa abẹla",
  "block.minecraft.red_carpet": "Pupa carpeti",
  "block.minecraft.red_concrete": "Nkan Pupa",
  "block.minecraft.red_concrete_powder": "Pupa ṣoki lulú",
  "block.minecraft.red_glazed_terracotta": "Red Glazed Terracotta",
  "block.minecraft.red_mushroom": "Olu pupa",
  "block.minecraft.red_mushroom_block": "Iwe-iṣiro pupa mycelium",
  "block.minecraft.red_nether_brick_slab": "Red Nether Brick Slab",
  "block.minecraft.red_nether_brick_stairs": "Nether Brick Stairs",
  "block.minecraft.red_nether_brick_wall": "Red Nether Brick Wall",
  "block.minecraft.red_nether_bricks": "Biriki Nether pupa",
  "block.minecraft.red_sand": "Iyanrin pupa",
  "block.minecraft.red_sandstone": "Pupa Iyanrinokuta",
  "block.minecraft.red_sandstone_slab": "Pupa apẹrẹ gusu",
  "block.minecraft.red_sandstone_stairs": "Pupa iyanrinokuta atẹgun",
  "block.minecraft.red_sandstone_wall": "Odi Pupa Sandstone",
  "block.minecraft.red_shulker_box": "Apoti Shulker Pupa",
  "block.minecraft.red_stained_glass": "Pupa gilasi",
  "block.minecraft.red_stained_glass_pane": "Pupa gilasi",
  "block.minecraft.red_terracotta": "Pupa terakota",
  "block.minecraft.red_tulip": "Pupa tulip",
  "block.minecraft.red_wool": "Pupa kìki irun",
  "block.minecraft.redstone_block": "Àkọsílẹ Ti Redstone",
  "block.minecraft.redstone_lamp": "Redstone Atupa",
  "block.minecraft.redstone_ore": "Redstone irin",
  "block.minecraft.redstone_torch": "Redstone ògùṣọ",
  "block.minecraft.redstone_wall_torch": "Tèsi ogiri ti a fi okuta pupa ṣe",
  "block.minecraft.redstone_wire": "Redstone irin",
  "block.minecraft.reinforced_deepslate": "Fikun Deepslate",
  "block.minecraft.repeater": "Atunṣe Redstone",
  "block.minecraft.repeating_command_block": "Tun Ipa Iṣẹ tun ṣe",
  "block.minecraft.resin_block": "Block of Resin",
  "block.minecraft.resin_brick_slab": "Resin Brick Slab",
  "block.minecraft.resin_brick_stairs": "Resin Brick Stairs",
  "block.minecraft.resin_brick_wall": "Resin Brick Wall",
  "block.minecraft.resin_bricks": "Resin Bricks",
  "block.minecraft.resin_clump": "Resin Clump",
  "block.minecraft.respawn_anchor": "Olupin respawn",
  "block.minecraft.rooted_dirt": "Dirt fidimule",
  "block.minecraft.rose_bush": "Abo igbo",
  "block.minecraft.sand": "Iyanrin",
  "block.minecraft.sandstone": "Iyanrinokuta",
  "block.minecraft.sandstone_slab": "Apẹrẹ gusu",
  "block.minecraft.sandstone_stairs": "Iyanrinokuta atẹgun",
  "block.minecraft.sandstone_wall": "Odi Sandstone",
  "block.minecraft.scaffolding": "Scaffolding",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "ayase sculk",
  "block.minecraft.sculk_sensor": "Sculk Sensọ",
  "block.minecraft.sculk_shrieker": "Sculk Shrieker",
  "block.minecraft.sculk_vein": "Iṣan Sculk",
  "block.minecraft.sea_lantern": "Okun Okun",
  "block.minecraft.sea_pickle": "Pupa Pickle",
  "block.minecraft.seagrass": "Seagrass",
  "block.minecraft.set_spawn": "Ṣeto ipo ti a tunṣe",
  "block.minecraft.short_dry_grass": "Short Dry Grass",
  "block.minecraft.short_grass": "Short Grass",
  "block.minecraft.shroomlight": "Itankalẹ yara",
  "block.minecraft.shulker_box": "Apoti Shulker",
  "block.minecraft.skeleton_skull": "Agbon timole",
  "block.minecraft.skeleton_wall_skull": "Oke-ori Oke-ọpẹ",
  "block.minecraft.slime_block": "Iwọn Ilana Slime",
  "block.minecraft.small_amethyst_bud": "Bud Amethyst Egbon",
  "block.minecraft.small_dripleaf": "Ewe Kekere Sisun",
  "block.minecraft.smithing_table": "Titiipa Smithing",
  "block.minecraft.smoker": "Smoker",
  "block.minecraft.smooth_basalt": "Dan Basalt",
  "block.minecraft.smooth_quartz": "Dẹkun Quartz Dẹkun",
  "block.minecraft.smooth_quartz_slab": "Smooth Quartz Slab",
  "block.minecraft.smooth_quartz_stairs": "Smooth Quartz Awọn atẹgun",
  "block.minecraft.smooth_red_sandstone": "Dudu pupa gusu",
  "block.minecraft.smooth_red_sandstone_slab": "Awọn Ọgbọn Ikun Iyanrin pupa",
  "block.minecraft.smooth_red_sandstone_stairs": "Awọn Irẹrin Sandstone pẹtẹpẹtẹ",
  "block.minecraft.smooth_sandstone": "Dudu gusu",
  "block.minecraft.smooth_sandstone_slab": "Dudu gusu",
  "block.minecraft.smooth_sandstone_stairs": "Awọn Igun Gilaasi Awọn Irẹrin",
  "block.minecraft.smooth_stone": "Dudu Okuta",
  "block.minecraft.smooth_stone_slab": "Awọn Ikọpọ Ọgbọn Ẹwa",
  "block.minecraft.sniffer_egg": "Sniffer ẹyin",
  "block.minecraft.snow": "Egbon",
  "block.minecraft.snow_block": "Isinmi apẹrẹ",
  "block.minecraft.soul_campfire": "Nipa ina ti ẹmi",
  "block.minecraft.soul_fire": "Ọrun Iná",
  "block.minecraft.soul_lantern": "Okun Okun",
  "block.minecraft.soul_sand": "Iyanrin ti ọkàn",
  "block.minecraft.soul_soil": "Ọkàn",
  "block.minecraft.soul_torch": "Ọkàn Torch",
  "block.minecraft.soul_wall_torch": "Ọkàn odi chgùṣọ",
  "block.minecraft.spawn.not_valid": "O ko ni ibusun ile tabi oran-iṣẹ ti a tunṣe pada, tabi o ti ni idiwọ",
  "block.minecraft.spawner": "Aderubaniyan Spawner",
  "block.minecraft.spawner.desc1": "Ṣe ajọṣepọ pẹlu Ẹyin Spawn:",
  "block.minecraft.spawner.desc2": "Ṣeto Agbajo eniyan Iru",
  "block.minecraft.sponge": "Kanrinkan",
  "block.minecraft.spore_blossom": "Spore Iruwe",
  "block.minecraft.spruce_button": "Bọtini Spruce",
  "block.minecraft.spruce_door": "Spruce enu",
  "block.minecraft.spruce_fence": "Spruce odi",
  "block.minecraft.spruce_fence_gate": "Spruce Ẹnubodè Pada",
  "block.minecraft.spruce_hanging_sign": "Spruce ikele Sign",
  "block.minecraft.spruce_leaves": "Spruce bunkun",
  "block.minecraft.spruce_log": "Spruce wọle",
  "block.minecraft.spruce_planks": "Ọkọ abẹrẹ",
  "block.minecraft.spruce_pressure_plate": "Iwọn Spruce Ipaju",
  "block.minecraft.spruce_sapling": "Ororoo dara",
  "block.minecraft.spruce_shelf": "Spruce Shelf",
  "block.minecraft.spruce_sign": "Egungun Spruce",
  "block.minecraft.spruce_slab": "Egungun Spruce",
  "block.minecraft.spruce_stairs": "Gbe atẹgun spruce",
  "block.minecraft.spruce_trapdoor": "Spruce Oṣuwọn",
  "block.minecraft.spruce_wall_hanging_sign": "Spruce Wall ikele Sign",
  "block.minecraft.spruce_wall_sign": "Spruce Wall Sign",
  "block.minecraft.spruce_wood": "Spruce igi",
  "block.minecraft.sticky_piston": "Piston alalepo",
  "block.minecraft.stone": "Okuta",
  "block.minecraft.stone_brick_slab": "Brick awo okuta",
  "block.minecraft.stone_brick_stairs": "Okuta Brick Awọn atẹsẹ",
  "block.minecraft.stone_brick_wall": "Okuta Brick Stone",
  "block.minecraft.stone_bricks": "Okuta biriki",
  "block.minecraft.stone_button": "Bọtini okuta",
  "block.minecraft.stone_pressure_plate": "Okuta atilẹyin Itoju",
  "block.minecraft.stone_slab": "Okuta awo",
  "block.minecraft.stone_stairs": "Okuta Okuta",
  "block.minecraft.stonecutter": "Ṣiṣẹ Stone",
  "block.minecraft.stripped_acacia_log": "Pa Acacia Wọle",
  "block.minecraft.stripped_acacia_wood": "Igi Acacia ti gbin",
  "block.minecraft.stripped_bamboo_block": "Àkọsílẹ ti ṣi kuro Bamboo",
  "block.minecraft.stripped_birch_log": "Ti pa Spruce Wọle",
  "block.minecraft.stripped_birch_wood": "Igi Birch ti a lu",
  "block.minecraft.stripped_cherry_log": "Ti pa Àgbálùmo Wọle",
  "block.minecraft.stripped_cherry_wood": "Igi Àgbálùmo ti a lu",
  "block.minecraft.stripped_crimson_hyphae": "Kọlu Crimson Hyphae",
  "block.minecraft.stripped_crimson_stem": "Kọlu Crimson Stem",
  "block.minecraft.stripped_dark_oak_log": "Wọle Oaku Wọle ti Dudu",
  "block.minecraft.stripped_dark_oak_wood": "Wọle Oaku Wọle ti Dudu",
  "block.minecraft.stripped_jungle_log": "Ti pa Spruce Wọle",
  "block.minecraft.stripped_jungle_wood": "Igi Igi ti a gbin",
  "block.minecraft.stripped_mangrove_log": "Si bọ Mangrove Wọle",
  "block.minecraft.stripped_mangrove_wood": "Si bọ Mangrove Wood",
  "block.minecraft.stripped_oak_log": "Ti pa Oka Wọle",
  "block.minecraft.stripped_oak_wood": "Igi Oaku ti a gbin",
  "block.minecraft.stripped_pale_oak_log": "Stripped Pale Oak Log",
  "block.minecraft.stripped_pale_oak_wood": "Stripped Pale Oak Wood",
  "block.minecraft.stripped_spruce_log": "Ti pa Spruce Wọle",
  "block.minecraft.stripped_spruce_wood": "Igi Igi ti a lu",
  "block.minecraft.stripped_warped_hyphae": "Kọlu Hyphae ti bajẹ",
  "block.minecraft.stripped_warped_stem": "Igbese Steped ti a ni nkan",
  "block.minecraft.structure_block": "Dẹkun igbekale",
  "block.minecraft.structure_void": "Ko si be",
  "block.minecraft.sugar_cane": "Ohun ọgbin",
  "block.minecraft.sunflower": "Oorun-ododo",
  "block.minecraft.suspicious_gravel": "Ifura Gravel",
  "block.minecraft.suspicious_sand": "Ipanu iyanrin",
  "block.minecraft.sweet_berry_bush": "Dun Bush Bush",
  "block.minecraft.tall_dry_grass": "Tall Dry Grass",
  "block.minecraft.tall_grass": "Wọle si ọna",
  "block.minecraft.tall_seagrass": "Ga Seagrass",
  "block.minecraft.target": "Ibi-afẹde",
  "block.minecraft.terracotta": "Terakota",
  "block.minecraft.test_block": "Test Block",
  "block.minecraft.test_instance_block": "Test Instance Block",
  "block.minecraft.tinted_glass": "Gilasi Tinted",
  "block.minecraft.tnt": "Ìmúdàgba",
  "block.minecraft.tnt.disabled": "TNT explosions are disabled",
  "block.minecraft.torch": "Ògùṣọ",
  "block.minecraft.torchflower": "Ògùṣọ Flower",
  "block.minecraft.torchflower_crop": "Ògùṣọ Flower irugbin na",
  "block.minecraft.trapped_chest": "Àyà pakute",
  "block.minecraft.trial_spawner": "Trial Spawner",
  "block.minecraft.tripwire": "Irin-ajo",
  "block.minecraft.tripwire_hook": "Tripwire ifikọti",
  "block.minecraft.tube_coral": "Coral Tube",
  "block.minecraft.tube_coral_block": "Akara Ideri Tube",
  "block.minecraft.tube_coral_fan": "A àìpẹ ti coral tubular",
  "block.minecraft.tube_coral_wall_fan": "Orilẹ-ibẹrẹ oniṣan ti adan apo",
  "block.minecraft.tuff": "Tuff",
  "block.minecraft.tuff_brick_slab": "Tuff Brick Slab",
  "block.minecraft.tuff_brick_stairs": "Tuff Brick Stairs",
  "block.minecraft.tuff_brick_wall": "Tuff Brick Wall",
  "block.minecraft.tuff_bricks": "Tuff Bricks",
  "block.minecraft.tuff_slab": "Tuff Slab",
  "block.minecraft.tuff_stairs": "Tuff Stairs",
  "block.minecraft.tuff_wall": "Tuff Wall",
  "block.minecraft.turtle_egg": "Ijapa ẹyin",
  "block.minecraft.twisting_vines": "Fọn igi àjara",
  "block.minecraft.twisting_vines_plant": "Fọn igi àjara",
  "block.minecraft.vault": "Ailewu",
  "block.minecraft.verdant_froglight": "Verdant Froglight",
  "block.minecraft.vine": "Ajara",
  "block.minecraft.void_air": "Odo Air",
  "block.minecraft.wall_torch": "Tilasi odi",
  "block.minecraft.warped_button": "Bọtini Ogun",
  "block.minecraft.warped_door": "Ilekun Warped",
  "block.minecraft.warped_fence": "Ogun ti Odi",
  "block.minecraft.warped_fence_gate": "Ẹnu ọ̀nà Fence",
  "block.minecraft.warped_fungus": "Dari Fungus",
  "block.minecraft.warped_hanging_sign": "Àmì Ìsokọ́ Òkè",
  "block.minecraft.warped_hyphae": "Hyphae ti Ogun",
  "block.minecraft.warped_nylium": "Nylium ti ogun",
  "block.minecraft.warped_planks": "Planks Planed",
  "block.minecraft.warped_pressure_plate": "Plateau Ipa Ipa",
  "block.minecraft.warped_roots": "Ogun Roots",
  "block.minecraft.warped_shelf": "Warped Shelf",
  "block.minecraft.warped_sign": "Ami Ami",
  "block.minecraft.warped_slab": "Slab ogun",
  "block.minecraft.warped_stairs": "Awọn pẹtẹẹsì ogun",
  "block.minecraft.warped_stem": "Igbiyanju",
  "block.minecraft.warped_trapdoor": "Trapdoor ti Ogun",
  "block.minecraft.warped_wall_hanging_sign": "Àmì Ìsokọ́ Ògiri",
  "block.minecraft.warped_wall_sign": "Ami Wall Warped",
  "block.minecraft.warped_wart_block": "Window Dena Wart",
  "block.minecraft.water": "Omi",
  "block.minecraft.water_cauldron": "Igbomikana omi",
  "block.minecraft.waxed_chiseled_copper": "Waxed Chiseled Copper",
  "block.minecraft.waxed_copper_bars": "Waxed Copper Bars",
  "block.minecraft.waxed_copper_block": "Epo-Epo ti Ejò",
  "block.minecraft.waxed_copper_bulb": "Waxed Copper Bulb",
  "block.minecraft.waxed_copper_chain": "Waxed Copper Chain",
  "block.minecraft.waxed_copper_chest": "Waxed Copper Chest",
  "block.minecraft.waxed_copper_door": "Waxed Copper Door",
  "block.minecraft.waxed_copper_golem_statue": "Waxed Copper Golem Statue",
  "block.minecraft.waxed_copper_grate": "Waxed Copper Grate",
  "block.minecraft.waxed_copper_lantern": "Waxed Copper Lantern",
  "block.minecraft.waxed_copper_trapdoor": "Waxed Copper Trapdoor",
  "block.minecraft.waxed_cut_copper": "Ejò Ge Ejò",
  "block.minecraft.waxed_cut_copper_slab": "Waxed Ge Ejò slab",
  "block.minecraft.waxed_cut_copper_stairs": "Waxed Ge Ejò pẹtẹẹsì",
  "block.minecraft.waxed_exposed_chiseled_copper": "Waxed Exposed Chiseled Copper",
  "block.minecraft.waxed_exposed_copper": "Ejò Ti A Fi Han",
  "block.minecraft.waxed_exposed_copper_bars": "Waxed Exposed Copper Bars",
  "block.minecraft.waxed_exposed_copper_bulb": "Waxed Exposed Copper Bulb",
  "block.minecraft.waxed_exposed_copper_chain": "Waxed Exposed Copper Chain",
  "block.minecraft.waxed_exposed_copper_chest": "Waxed Exposed Copper Chest",
  "block.minecraft.waxed_exposed_copper_door": "Waxed Exposed Copper Door",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Waxed Exposed Copper Golem Statue",
  "block.minecraft.waxed_exposed_copper_grate": "Waxed Exposed Copper Grate",
  "block.minecraft.waxed_exposed_copper_lantern": "Waxed Exposed Copper Lantern",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Waxed Exposed Copper Trapdoor",
  "block.minecraft.waxed_exposed_cut_copper": "Waxed Exposed Cut Copper",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Waxed Fifi Ge Ejò Slab",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Waxed fara han Ejò pẹtẹẹsì",
  "block.minecraft.waxed_exposed_lightning_rod": "Waxed Exposed Lightning Rod",
  "block.minecraft.waxed_lightning_rod": "Waxed Lightning Rod",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Waxed Oxidized Chiseled Copper",
  "block.minecraft.waxed_oxidized_copper": "Ejò Oxidized Waxed",
  "block.minecraft.waxed_oxidized_copper_bars": "Waxed Oxidized Copper Bars",
  "block.minecraft.waxed_oxidized_copper_bulb": "Waxed Oxidized Copper Bulb",
  "block.minecraft.waxed_oxidized_copper_chain": "Waxed Oxidized Copper Chain",
  "block.minecraft.waxed_oxidized_copper_chest": "Waxed Oxidized Copper Chest",
  "block.minecraft.waxed_oxidized_copper_door": "Waxed Oxidized Copper Door",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Waxed Oxidized Copper Golem Statue",
  "block.minecraft.waxed_oxidized_copper_grate": "Waxed Oxidized Copper Grate",
  "block.minecraft.waxed_oxidized_copper_lantern": "Waxed Oxidized Copper Lantern",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Waxed Oxidized Copper Trapdoor",
  "block.minecraft.waxed_oxidized_cut_copper": "Waxed Oxidized Ge Ejò",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Waxed Oxidized Ge Ejò Slab",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Waxed Oxidized Ge Ejò pẹtẹẹsì",
  "block.minecraft.waxed_oxidized_lightning_rod": "Waxed Oxidized Lightning Rod",
  "block.minecraft.waxed_weathered_chiseled_copper": "Waxed Weathered Chiseled Copper",
  "block.minecraft.waxed_weathered_copper": "Ejò oju-ojo ti a fi epo-eti ṣe",
  "block.minecraft.waxed_weathered_copper_bars": "Waxed Weathered Copper Bars",
  "block.minecraft.waxed_weathered_copper_bulb": "Waxed Weathered Copper Bulb",
  "block.minecraft.waxed_weathered_copper_chain": "Waxed Weathered Copper Chain",
  "block.minecraft.waxed_weathered_copper_chest": "Waxed Weathered Copper Chest",
  "block.minecraft.waxed_weathered_copper_door": "Waxed Weathered Copper Door",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Waxed Weathered Copper Golem Statue",
  "block.minecraft.waxed_weathered_copper_grate": "Waxed Weathered Copper Grate",
  "block.minecraft.waxed_weathered_copper_lantern": "Waxed Weathered Copper Lantern",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Waxed Weathered Copper Trapdoor",
  "block.minecraft.waxed_weathered_cut_copper": "Waxed Weathered Ge Ejò",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Waxed Weathered Ge Ejò Slab",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Waxed Weathered Ge Ejò pẹtẹẹsì",
  "block.minecraft.waxed_weathered_lightning_rod": "Waxed Weathered Lightning Rod",
  "block.minecraft.weathered_chiseled_copper": "Weathered Chiseled Copper",
  "block.minecraft.weathered_copper": "Ejò Oju Ojo",
  "block.minecraft.weathered_copper_bars": "Weathered Copper Bars",
  "block.minecraft.weathered_copper_bulb": "Weathered Copper Bulb",
  "block.minecraft.weathered_copper_chain": "Weathered Copper Chain",
  "block.minecraft.weathered_copper_chest": "Weathered Copper Chest",
  "block.minecraft.weathered_copper_door": "Weathered Copper Door",
  "block.minecraft.weathered_copper_golem_statue": "Weathered Copper Golem Statue",
  "block.minecraft.weathered_copper_grate": "Weathered Copper Grate",
  "block.minecraft.weathered_copper_lantern": "Weathered Copper Lantern",
  "block.minecraft.weathered_copper_trapdoor": "Weathered Copper Trapdoor",
  "block.minecraft.weathered_cut_copper": "Oju Ojo Ge Ejò",
  "block.minecraft.weathered_cut_copper_slab": "Weathered Ge Ejò Slab",
  "block.minecraft.weathered_cut_copper_stairs": "Weathered Ge Ejò pẹtẹẹsì",
  "block.minecraft.weathered_lightning_rod": "Weathered Lightning Rod",
  "block.minecraft.weeping_vines": "Ẹkun Ajara",
  "block.minecraft.weeping_vines_plant": "Gbin ọgbin",
  "block.minecraft.wet_sponge": "Tutu kanrinkan",
  "block.minecraft.wheat": "Alikama irugbin igi",
  "block.minecraft.white_banner": "Banner Funfun",
  "block.minecraft.white_bed": "Funfun Ibusun",
  "block.minecraft.white_candle": "Funfun Abẹla",
  "block.minecraft.white_candle_cake": "Akara oyinbo pẹlu funfun abẹla",
  "block.minecraft.white_carpet": "Funfun capeti",
  "block.minecraft.white_concrete": "Nkan funfun",
  "block.minecraft.white_concrete_powder": "Funfun ṣoki ti funfun",
  "block.minecraft.white_glazed_terracotta": "Funfun Glazed Terracotta",
  "block.minecraft.white_shulker_box": "Apoti Shulker Funfun",
  "block.minecraft.white_stained_glass": "Funfun gilasi",
  "block.minecraft.white_stained_glass_pane": "Funfun gilasi",
  "block.minecraft.white_terracotta": "Funfun teracota",
  "block.minecraft.white_tulip": "Funfun tulip",
  "block.minecraft.white_wool": "Funfun kìki irun",
  "block.minecraft.wildflowers": "Wildflowers",
  "block.minecraft.wither_rose": "Wither Soke",
  "block.minecraft.wither_skeleton_skull": "Wither egungun timole",
  "block.minecraft.wither_skeleton_wall_skull": "Wull Oke Ogun-ọṣọ Wke",
  "block.minecraft.yellow_banner": "Asia Yellow",
  "block.minecraft.yellow_bed": "Ibusun Ofeefee",
  "block.minecraft.yellow_candle": "Ofeefee Abẹla",
  "block.minecraft.yellow_candle_cake": "Akara oyinbo pẹlu Ofeefee abẹla",
  "block.minecraft.yellow_carpet": "Iyeye carpeti",
  "block.minecraft.yellow_concrete": "Ohun ọṣọ alawọ",
  "block.minecraft.yellow_concrete_powder": "Ipara alawọ ofeefee",
  "block.minecraft.yellow_glazed_terracotta": "Yellow Glazed Terracotta",
  "block.minecraft.yellow_shulker_box": "Apoti Shulker Yellow",
  "block.minecraft.yellow_stained_glass": "Iyeye gilasi",
  "block.minecraft.yellow_stained_glass_pane": "Iyeye gilasi",
  "block.minecraft.yellow_terracotta": "Iyeye terakota",
  "block.minecraft.yellow_wool": "Iyeye kìki irun",
  "block.minecraft.zombie_head": "Zombie ori",
  "block.minecraft.zombie_wall_head": "Orile-ori Zombie Odi",
  "item.minecraft.acacia_boat": "Okọ akasia",
  "item.minecraft.acacia_chest_boat": "Acacia ọkọ oju-omi kekere pẹlu àyà",
  "item.minecraft.allay_spawn_egg": "Allay Ẹyin Spawn",
  "item.minecraft.amethyst_shard": "Amethyst Shard",
  "item.minecraft.angler_pottery_shard": "Angler apadì o Shard",
  "item.minecraft.angler_pottery_sherd": "Angler apadì o Sherd",
  "item.minecraft.apple": "Àpù",
  "item.minecraft.archer_pottery_shard": "Archer apadì o Shard",
  "item.minecraft.archer_pottery_sherd": "Archer apadì o Sherd",
  "item.minecraft.armadillo_scute": "Armadillo Scute",
  "item.minecraft.armadillo_spawn_egg": "Armadillo Spawn Egg",
  "item.minecraft.armor_stand": "Ihamọra Imurasilẹ",
  "item.minecraft.arms_up_pottery_shard": "Arms Up apadì o Shard",
  "item.minecraft.arms_up_pottery_sherd": "Arms Up apadì o Sherd",
  "item.minecraft.arrow": "Ọfa",
  "item.minecraft.axolotl_bucket": "Garawa ti Axolotl",
  "item.minecraft.axolotl_spawn_egg": "Axolotl Spawn Ẹyin",
  "item.minecraft.baked_potato": "Ndin Ọdunkun",
  "item.minecraft.bamboo_chest_raft": "Bamboo Raft pẹlu àyà",
  "item.minecraft.bamboo_raft": "Oparun Raft",
  "item.minecraft.bat_spawn_egg": "Ẹyin pe pipe",
  "item.minecraft.bee_spawn_egg": "Ẹyin Bee Spawn",
  "item.minecraft.beef": "Aise Eran Malu",
  "item.minecraft.beetroot": "Beetroot",
  "item.minecraft.beetroot_seeds": "Beetroot Irugbin",
  "item.minecraft.beetroot_soup": "Bimo Beetroot",
  "item.minecraft.birch_boat": "Oko birch",
  "item.minecraft.birch_chest_boat": "Ọkọ oju omi Birch pẹlu àyà",
  "item.minecraft.black_bundle": "Black Bundle",
  "item.minecraft.black_dye": "Dudu dai",
  "item.minecraft.black_harness": "Black Harness",
  "item.minecraft.blade_pottery_shard": "Blade apadì o Shard",
  "item.minecraft.blade_pottery_sherd": "Blade apadì o Sherd",
  "item.minecraft.blaze_powder": "Blaze lulú",
  "item.minecraft.blaze_rod": "Blaze ọpá",
  "item.minecraft.blaze_spawn_egg": "Ẹyin pe kan ina",
  "item.minecraft.blue_bundle": "Blue Bundle",
  "item.minecraft.blue_dye": "Awọ bulu",
  "item.minecraft.blue_egg": "Blue Egg",
  "item.minecraft.blue_harness": "Blue Harness",
  "item.minecraft.bogged_spawn_egg": "Bogged Spawn Egg",
  "item.minecraft.bolt_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Bolt Armor Trim",
  "item.minecraft.bone": "Egungun",
  "item.minecraft.bone_meal": "Ounjẹ Egungun",
  "item.minecraft.book": "Iwe",
  "item.minecraft.bordure_indented_banner_pattern": "Bordure Indented Banner Pattern",
  "item.minecraft.bow": "Teriba",
  "item.minecraft.bowl": "Abọ",
  "item.minecraft.bread": "Búrẹ́dì",
  "item.minecraft.breeze_rod": "Breeze Rod",
  "item.minecraft.breeze_spawn_egg": "Breeze Spawn Egg",
  "item.minecraft.brewer_pottery_shard": "Brewer apadì o Shard",
  "item.minecraft.brewer_pottery_sherd": "Brewer apadì o Sherd",
  "item.minecraft.brewing_stand": "Pipọnti imurasilẹ",
  "item.minecraft.brick": "Okuta",
  "item.minecraft.brown_bundle": "Brown Bundle",
  "item.minecraft.brown_dye": "Awọ dai",
  "item.minecraft.brown_egg": "Brown Egg",
  "item.minecraft.brown_harness": "Brown Harness",
  "item.minecraft.brush": "Burọṣi",
  "item.minecraft.bucket": "Garawa",
  "item.minecraft.bundle": "Apapo",
  "item.minecraft.bundle.empty": "Empty",
  "item.minecraft.bundle.empty.description": "Can hold a mixed stack of items",
  "item.minecraft.bundle.full": "Full",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Iná apadì o Shard",
  "item.minecraft.burn_pottery_sherd": "Iná apadì o Sherd",
  "item.minecraft.camel_husk_spawn_egg": "Camel Husk Spawn Egg",
  "item.minecraft.camel_spawn_egg": "Rakunmi Spawn Ẹyin",
  "item.minecraft.carrot": "Karọọti",
  "item.minecraft.carrot_on_a_stick": "Karooti lori Ọpá kan",
  "item.minecraft.cat_spawn_egg": "Ṣẹda o nran kan",
  "item.minecraft.cauldron": "Cauldron",
  "item.minecraft.cave_spider_spawn_egg": "Ẹyin pipe ni agbọn egungun kan",
  "item.minecraft.chainmail_boots": "Bata pq",
  "item.minecraft.chainmail_chestplate": "Ipa-ọṣọ",
  "item.minecraft.chainmail_helmet": "Ipele ibori",
  "item.minecraft.chainmail_leggings": "Ohun elo gbigbe",
  "item.minecraft.charcoal": "Eedu",
  "item.minecraft.cherry_boat": "Ọkọ oju omi Àgbálùmo",
  "item.minecraft.cherry_chest_boat": "Àgbálùmo ọkọ oju-omi kekere pẹlu àyà",
  "item.minecraft.chest_minecart": "Minecart pẹlu àya",
  "item.minecraft.chicken": "Adie Aise",
  "item.minecraft.chicken_spawn_egg": "Ẹyin pipe kan gboo",
  "item.minecraft.chorus_fruit": "Chorus Eso",
  "item.minecraft.clay_ball": "Odidi amọ",
  "item.minecraft.clock": "Aago",
  "item.minecraft.coal": "Alóró",
  "item.minecraft.coast_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Coast Armor Trim",
  "item.minecraft.cocoa_beans": "Koko Ewa",
  "item.minecraft.cod": "Iwọn Ipele",
  "item.minecraft.cod_bucket": "Garawa pẹlu cod",
  "item.minecraft.cod_spawn_egg": "Ẹyin pipe fun cod",
  "item.minecraft.command_block_minecart": "Minecart pẹlu Àṣẹ Àkọsílẹ",
  "item.minecraft.compass": "Kọmpasi",
  "item.minecraft.cooked_beef": "Steak",
  "item.minecraft.cooked_chicken": "Adie jinna",
  "item.minecraft.cooked_cod": "Ṣunna ẹja kan",
  "item.minecraft.cooked_mutton": "Mutton jinna",
  "item.minecraft.cooked_porkchop": "Jinna ẹlẹdẹ",
  "item.minecraft.cooked_rabbit": "Ehoro jinna",
  "item.minecraft.cooked_salmon": "Salmoni ti a jinna",
  "item.minecraft.cookie": "Kuki",
  "item.minecraft.copper_axe": "Copper Axe",
  "item.minecraft.copper_boots": "Copper Boots",
  "item.minecraft.copper_chestplate": "Copper Chestplate",
  "item.minecraft.copper_golem_spawn_egg": "Copper Golem Spawn Egg",
  "item.minecraft.copper_helmet": "Copper Helmet",
  "item.minecraft.copper_hoe": "Copper Hoe",
  "item.minecraft.copper_horse_armor": "Copper Horse Armor",
  "item.minecraft.copper_ingot": "Ejò Ingot",
  "item.minecraft.copper_leggings": "Copper Leggings",
  "item.minecraft.copper_nautilus_armor": "Copper Nautilus Armor",
  "item.minecraft.copper_nugget": "Copper Nugget",
  "item.minecraft.copper_pickaxe": "Copper Pickaxe",
  "item.minecraft.copper_shovel": "Copper Shovel",
  "item.minecraft.copper_spear": "Copper Spear",
  "item.minecraft.copper_sword": "Copper Sword",
  "item.minecraft.cow_spawn_egg": "Ẹyin pipe kan Maalu",
  "item.minecraft.creaking_spawn_egg": "Creaking Spawn Egg",
  "item.minecraft.creeper_banner_pattern": "Apẹrẹ Apẹrẹ",
  "item.minecraft.creeper_banner_pattern.desc": "Gbigba agbara Creeper",
  "item.minecraft.creeper_banner_pattern.new": "Creeper Charge Banner Pattern",
  "item.minecraft.creeper_spawn_egg": "Ẹyin pipe Creeper",
  "item.minecraft.crossbow": "Crossbow",
  "item.minecraft.crossbow.projectile": "Ise agbese:",
  "item.minecraft.crossbow.projectile.multiple": "Projectile: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Projectile: %s",
  "item.minecraft.cyan_bundle": "Cyan Bundle",
  "item.minecraft.cyan_dye": "Awọ Cyan",
  "item.minecraft.cyan_harness": "Cyan Harness",
  "item.minecraft.danger_pottery_shard": "Ewu apadì o Shard",
  "item.minecraft.danger_pottery_sherd": "Ewu apadì o Sherd",
  "item.minecraft.dark_oak_boat": "Okọ oju omi oaku dudu",
  "item.minecraft.dark_oak_chest_boat": "Egbe igi oak dudu pẹlu àyà",
  "item.minecraft.debug_stick": "Ọpa alaburo",
  "item.minecraft.debug_stick.empty": "%s ko ni ohun-ini kan",
  "item.minecraft.debug_stick.select": "ti a ti yan \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" ṣeto si %s",
  "item.minecraft.diamond": "Alumọni",
  "item.minecraft.diamond_axe": "Okuta Ẹsọ́",
  "item.minecraft.diamond_boots": "Bata Orunkun",
  "item.minecraft.diamond_chestplate": "Okuta Iyebiye",
  "item.minecraft.diamond_helmet": "Ibori Diamond",
  "item.minecraft.diamond_hoe": "Hoe Iyebiye",
  "item.minecraft.diamond_horse_armor": "Ihamọra ẹṣin iyebiye",
  "item.minecraft.diamond_leggings": "Awọn Okuta Iyebiye",
  "item.minecraft.diamond_nautilus_armor": "Diamond Nautilus Armor",
  "item.minecraft.diamond_pickaxe": "Apata Diamondka",
  "item.minecraft.diamond_shovel": "Iyanrin Diamond",
  "item.minecraft.diamond_spear": "Diamond Spear",
  "item.minecraft.diamond_sword": "Idẹ Diamond",
  "item.minecraft.disc_fragment_5": "Disiki dissi",
  "item.minecraft.disc_fragment_5.desc": "Diski Orin - 5",
  "item.minecraft.dolphin_spawn_egg": "Ẹyin pe ẹja kan",
  "item.minecraft.donkey_spawn_egg": "Ẹyin pe ọmọ kẹtẹkẹtẹ kan",
  "item.minecraft.dragon_breath": "Ìmí ti Dragon",
  "item.minecraft.dried_kelp": "Omi omi ti o gbẹ",
  "item.minecraft.drowned_spawn_egg": "Ẹyin pe olutọru",
  "item.minecraft.dune_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Dune Armor Trim",
  "item.minecraft.echo_shard": "Iwoyi shard",
  "item.minecraft.egg": "Ẹyin",
  "item.minecraft.elder_guardian_spawn_egg": "Ẹyin pe aṣoju alagba",
  "item.minecraft.elytra": "Elytra",
  "item.minecraft.emerald": "Emerald",
  "item.minecraft.enchanted_book": "Iwe Enchanted",
  "item.minecraft.enchanted_golden_apple": "Àpù wúrà àdánidára",
  "item.minecraft.end_crystal": "End gara",
  "item.minecraft.ender_dragon_spawn_egg": "Ẹyin pe Ender Dragon",
  "item.minecraft.ender_eye": "Oju ti Ender",
  "item.minecraft.ender_pearl": "Ender parili",
  "item.minecraft.enderman_spawn_egg": "Ẹyin pe Enderman",
  "item.minecraft.endermite_spawn_egg": "Ẹyin pe Endermite",
  "item.minecraft.evoker_spawn_egg": "Ẹyin ti o pe olupe naa",
  "item.minecraft.experience_bottle": "Igo o' Enchanting",
  "item.minecraft.explorer_pottery_shard": "Explorer Iseamokoko Shard",
  "item.minecraft.explorer_pottery_sherd": "Explorer Iseamokoko Sherd",
  "item.minecraft.eye_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Eye Armor Trim",
  "item.minecraft.feather": "Ẹyẹ",
  "item.minecraft.fermented_spider_eye": "Fermented Oju Alantaku",
  "item.minecraft.field_masoned_banner_pattern": "Field Masoned Banner Pattern",
  "item.minecraft.filled_map": "Maapu",
  "item.minecraft.fire_charge": "Ina Idiyele",
  "item.minecraft.firework_rocket": "Ise ina Rocket",
  "item.minecraft.firework_rocket.flight": "Akoko Ofurufu:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Ise ina Irawo",
  "item.minecraft.firework_star.black": "Dudu",
  "item.minecraft.firework_star.blue": "Bulu",
  "item.minecraft.firework_star.brown": "Brown",
  "item.minecraft.firework_star.custom_color": "Aṣa",
  "item.minecraft.firework_star.cyan": "Cyan",
  "item.minecraft.firework_star.fade_to": "Fade si",
  "item.minecraft.firework_star.flicker": "Didan",
  "item.minecraft.firework_star.gray": "Grẹy",
  "item.minecraft.firework_star.green": "Alawọ ewe",
  "item.minecraft.firework_star.light_blue": "Imọlẹ Bulu",
  "item.minecraft.firework_star.light_gray": "Grẹy Imọlẹ",
  "item.minecraft.firework_star.lime": "Orombo wewe",
  "item.minecraft.firework_star.magenta": "Magenta",
  "item.minecraft.firework_star.orange": "Ọsan",
  "item.minecraft.firework_star.pink": "Pink",
  "item.minecraft.firework_star.purple": "Eleyi ti",
  "item.minecraft.firework_star.red": "Pupa",
  "item.minecraft.firework_star.shape": "Apẹrẹ Aimọ",
  "item.minecraft.firework_star.shape.burst": "Fonkaakiri",
  "item.minecraft.firework_star.shape.creeper": "Ipele ti Creeper",
  "item.minecraft.firework_star.shape.large_ball": "Bọọlu Nla",
  "item.minecraft.firework_star.shape.small_ball": "Bọọlu Kekere",
  "item.minecraft.firework_star.shape.star": "Irisi irawọ",
  "item.minecraft.firework_star.trail": "Itọpa",
  "item.minecraft.firework_star.white": "Funfun",
  "item.minecraft.firework_star.yellow": "Ofeefee",
  "item.minecraft.fishing_rod": "Igi ipẹja",
  "item.minecraft.flint": "Okuta",
  "item.minecraft.flint_and_steel": "Flint ati Irin",
  "item.minecraft.flow_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Flow Armor Trim",
  "item.minecraft.flow_banner_pattern": "Banner Pattern",
  "item.minecraft.flow_banner_pattern.desc": "Flow",
  "item.minecraft.flow_banner_pattern.new": "Flow Banner Pattern",
  "item.minecraft.flow_pottery_sherd": "Flow Pottery Sherd",
  "item.minecraft.flower_banner_pattern": "Apẹẹrẹ asia",
  "item.minecraft.flower_banner_pattern.desc": "Gbigba Ododo",
  "item.minecraft.flower_banner_pattern.new": "Flower Charge Banner Pattern",
  "item.minecraft.flower_pot": "Ikoko Adodo",
  "item.minecraft.fox_spawn_egg": "Fox ṣiṣe",
  "item.minecraft.friend_pottery_shard": "Ọrẹ Pottery Shard",
  "item.minecraft.friend_pottery_sherd": "Ọrẹ Pottery Sherd",
  "item.minecraft.frog_spawn_egg": "Ọpọlọ Spawn Ẹyin",
  "item.minecraft.furnace_minecart": "Minecart pẹlu ileru",
  "item.minecraft.ghast_spawn_egg": "Ẹyin pe Ghast",
  "item.minecraft.ghast_tear": "Ghast omije",
  "item.minecraft.glass_bottle": "Igo Gilasi",
  "item.minecraft.glistering_melon_slice": "Giṣẹ Melon Ibẹbẹ",
  "item.minecraft.globe_banner_pattern": "Apẹẹrẹ asia",
  "item.minecraft.globe_banner_pattern.desc": "Agbaiye",
  "item.minecraft.globe_banner_pattern.new": "Globe Banner Pattern",
  "item.minecraft.glow_berries": "Alábá Berries",
  "item.minecraft.glow_ink_sac": "Alábá Inki Sac",
  "item.minecraft.glow_item_frame": "Fireemu Ohun Ina",
  "item.minecraft.glow_squid_spawn_egg": "Alábá Squid Spawn Ẹyin",
  "item.minecraft.glowstone_dust": "Ekuru Glowstone",
  "item.minecraft.goat_horn": "Iwo ewurẹ",
  "item.minecraft.goat_spawn_egg": "Ewure Spawn Egg",
  "item.minecraft.gold_ingot": "Goolu Ingot",
  "item.minecraft.gold_nugget": "Ohun Elo Goolu",
  "item.minecraft.golden_apple": "Àpù wúrà",
  "item.minecraft.golden_axe": "Axórí. fin",
  "item.minecraft.golden_boots": "Awọn Bata Goolu",
  "item.minecraft.golden_carrot": "Karooti Goolu",
  "item.minecraft.golden_chestplate": "Aṣayan Ẹlẹsẹ wura",
  "item.minecraft.golden_helmet": "Àṣíborí Oníwúrà",
  "item.minecraft.golden_hoe": "Hórégé",
  "item.minecraft.golden_horse_armor": "Golden ẹṣin ihamọra",
  "item.minecraft.golden_leggings": "Awọn Leggings Goolu",
  "item.minecraft.golden_nautilus_armor": "Golden Nautilus Armor",
  "item.minecraft.golden_pickaxe": "Ẹwẹ Pickaxe",
  "item.minecraft.golden_shovel": "Ṣẹfulu ti wura",
  "item.minecraft.golden_spear": "Golden Spear",
  "item.minecraft.golden_sword": "Idà Golden",
  "item.minecraft.gray_bundle": "Gray Bundle",
  "item.minecraft.gray_dye": "Grẹy Dai",
  "item.minecraft.gray_harness": "Gray Harness",
  "item.minecraft.green_bundle": "Green Bundle",
  "item.minecraft.green_dye": "Awo Alawọ",
  "item.minecraft.green_harness": "Green Harness",
  "item.minecraft.guardian_spawn_egg": "Ẹyin pe olutọju",
  "item.minecraft.gunpowder": "Epo ibon",
  "item.minecraft.guster_banner_pattern": "Banner Pattern",
  "item.minecraft.guster_banner_pattern.desc": "Guster",
  "item.minecraft.guster_banner_pattern.new": "Guster Banner Pattern",
  "item.minecraft.guster_pottery_sherd": "Guster Pottery Sherd",
  "item.minecraft.happy_ghast_spawn_egg": "Happy Ghast Spawn Egg",
  "item.minecraft.harness": "Harness",
  "item.minecraft.heart_of_the_sea": "Okan ti okun",
  "item.minecraft.heart_pottery_shard": "Okan apadì o Shard",
  "item.minecraft.heart_pottery_sherd": "Okan apadì o Sherd",
  "item.minecraft.heartbreak_pottery_shard": "Heartbreak Iseamokoko Shard",
  "item.minecraft.heartbreak_pottery_sherd": "Heartbreak Iseamokoko Sherd",
  "item.minecraft.hoglin_spawn_egg": "Ẹyin Hoglin Summon",
  "item.minecraft.honey_bottle": "Igo Ipara",
  "item.minecraft.honeycomb": "Oyin oyin",
  "item.minecraft.hopper_minecart": "Minecart pẹlu Hopper",
  "item.minecraft.horse_spawn_egg": "Ẹyin pe ẹṣin",
  "item.minecraft.host_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.host_armor_trim_smithing_template.new": "Host Armor Trim",
  "item.minecraft.howl_pottery_shard": "Howl apadì o Shard",
  "item.minecraft.howl_pottery_sherd": "Howl apadì o Sherd",
  "item.minecraft.husk_spawn_egg": "Ẹyin pipe fun ogbele",
  "item.minecraft.ink_sac": "Inki Sac",
  "item.minecraft.iron_axe": "Axe Iron",
  "item.minecraft.iron_boots": "Irin Boots",
  "item.minecraft.iron_chestplate": "Irin Chestplate",
  "item.minecraft.iron_golem_spawn_egg": "Iron Golem Spawn Ẹyin",
  "item.minecraft.iron_helmet": "Ibori Irin",
  "item.minecraft.iron_hoe": "Irin Iron",
  "item.minecraft.iron_horse_armor": "Ihamọra ẹṣin irin",
  "item.minecraft.iron_ingot": "Iron Ingot",
  "item.minecraft.iron_leggings": "Irin Leggings",
  "item.minecraft.iron_nautilus_armor": "Iron Nautilus Armor",
  "item.minecraft.iron_nugget": "Irin Nugget",
  "item.minecraft.iron_pickaxe": "Iron Pickaxe",
  "item.minecraft.iron_shovel": "Isele irin",
  "item.minecraft.iron_spear": "Iron Spear",
  "item.minecraft.iron_sword": "Idà Iron",
  "item.minecraft.item_frame": "Fireemu Ohunkan",
  "item.minecraft.jungle_boat": "Okọ oju omi igbo",
  "item.minecraft.jungle_chest_boat": "Gungle ọkọ oju omi pẹlu àyà",
  "item.minecraft.knowledge_book": "Iwe Imọ",
  "item.minecraft.lapis_lazuli": "Lapis Lazuli",
  "item.minecraft.lava_bucket": "Lava Garawa",
  "item.minecraft.lead": "Asiwaju",
  "item.minecraft.leather": "Awọ",
  "item.minecraft.leather_boots": "Alawọ orunkun",
  "item.minecraft.leather_chestplate": "Alawọ tunic",
  "item.minecraft.leather_helmet": "Alawọ fila",
  "item.minecraft.leather_horse_armor": "Ologun ẹṣin ẹṣin",
  "item.minecraft.leather_leggings": "Awọn sokoto alawọ",
  "item.minecraft.light_blue_bundle": "Light Blue Bundle",
  "item.minecraft.light_blue_dye": "Awọ bulu didan",
  "item.minecraft.light_blue_harness": "Light Blue Harness",
  "item.minecraft.light_gray_bundle": "Light Gray Bundle",
  "item.minecraft.light_gray_dye": "Ina Grẹy",
  "item.minecraft.light_gray_harness": "Light Gray Harness",
  "item.minecraft.lime_bundle": "Lime Bundle",
  "item.minecraft.lime_dye": "Orombo Wewe",
  "item.minecraft.lime_harness": "Lime Harness",
  "item.minecraft.lingering_potion": "Pẹ Ogun",
  "item.minecraft.lingering_potion.effect.awkward": "Irẹwẹsi Lingering Iwon",
  "item.minecraft.lingering_potion.effect.empty": "Lingering Uncraftable Iwon",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Lingering Iwon ti Ina Atako",
  "item.minecraft.lingering_potion.effect.harming": "Lingering Iwon ti Ipalara",
  "item.minecraft.lingering_potion.effect.healing": "Lingering Iwon ti Iwosan",
  "item.minecraft.lingering_potion.effect.infested": "Lingering Potion of Infestation",
  "item.minecraft.lingering_potion.effect.invisibility": "Lingering Iwon ti Alaihan",
  "item.minecraft.lingering_potion.effect.leaping": "Lingering Iwon ti Fifo",
  "item.minecraft.lingering_potion.effect.levitation": "Ekun Ikun ti Levititi",
  "item.minecraft.lingering_potion.effect.luck": "Lingering Iwon ti Orire",
  "item.minecraft.lingering_potion.effect.mundane": "Mundane Lingering Iwon",
  "item.minecraft.lingering_potion.effect.night_vision": "Lingering Iwon ti Alẹ Iran",
  "item.minecraft.lingering_potion.effect.oozing": "Lingering Potion of Oozing",
  "item.minecraft.lingering_potion.effect.poison": "Ikun ti Majele",
  "item.minecraft.lingering_potion.effect.regeneration": "Ẹdun ti Isọdọtun",
  "item.minecraft.lingering_potion.effect.slow_falling": "Imuduro afẹfẹ ti isinku rọra",
  "item.minecraft.lingering_potion.effect.slowness": "Lingering Iwon ti Fifalẹ",
  "item.minecraft.lingering_potion.effect.strength": "Lingering Iwon ti Agbara",
  "item.minecraft.lingering_potion.effect.swiftness": "Lingering Iwon ti Kánkán",
  "item.minecraft.lingering_potion.effect.thick": "Nipọn Lingering Iwon",
  "item.minecraft.lingering_potion.effect.turtle_master": "Adalu pipẹ ti oluwa erupẹ",
  "item.minecraft.lingering_potion.effect.water": "Lingering Omi Igo",
  "item.minecraft.lingering_potion.effect.water_breathing": "Lingering Iwon ti Mimi Omi",
  "item.minecraft.lingering_potion.effect.weakness": "Ikun Ikun ti Ailera",
  "item.minecraft.lingering_potion.effect.weaving": "Lingering Potion of Weaving",
  "item.minecraft.lingering_potion.effect.wind_charged": "Lingering Potion of Wind Charging",
  "item.minecraft.llama_spawn_egg": "Ẹyin pe laini",
  "item.minecraft.lodestone_compass": "Oofa",
  "item.minecraft.mace": "Mace",
  "item.minecraft.magenta_bundle": "Magenta Bundle",
  "item.minecraft.magenta_dye": "Magenta dai",
  "item.minecraft.magenta_harness": "Magenta Harness",
  "item.minecraft.magma_cream": "Ipara Magma",
  "item.minecraft.magma_cube_spawn_egg": "Ẹyin ti n pe kọnisi magma",
  "item.minecraft.mangrove_boat": "Ọkọ oju omi mangove",
  "item.minecraft.mangrove_chest_boat": "Ọkọ oju omi kekere pẹlu àyà",
  "item.minecraft.map": "Sofo Maapu",
  "item.minecraft.melon_seeds": "Awọn irugbin Melon",
  "item.minecraft.melon_slice": "A nkan ti elegede",
  "item.minecraft.milk_bucket": "Wara garawa",
  "item.minecraft.minecart": "Minecart",
  "item.minecraft.miner_pottery_shard": "Miner Pottery Shard",
  "item.minecraft.miner_pottery_sherd": "Miner Pottery Sherd",
  "item.minecraft.mojang_banner_pattern": "Apẹẹrẹ asia",
  "item.minecraft.mojang_banner_pattern.desc": "Ohun",
  "item.minecraft.mojang_banner_pattern.new": "Thing Banner Pattern",
  "item.minecraft.mooshroom_spawn_egg": "Ẹyin pe eran Maalu kan",
  "item.minecraft.mourner_pottery_shard": "Mourner apadì o Shard",
  "item.minecraft.mourner_pottery_sherd": "Mourner apadì o Sherd",
  "item.minecraft.mule_spawn_egg": "Ẹyin pe ikun kan",
  "item.minecraft.mushroom_stew": "Ipẹtẹ Olu",
  "item.minecraft.music_disc_11": "Diski Orin",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Disiki Orin",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Diski Orin",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Disiki Orin",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Diski Orin",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Diski Orin",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Music Disc",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Music Disc",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Music Box)",
  "item.minecraft.music_disc_far": "Diski Orin",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Music Disc",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Diski Orin",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Diski Orin",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi\n",
  "item.minecraft.music_disc_otherside": "Diski Orin",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - miiran",
  "item.minecraft.music_disc_pigstep": "Diski Orin",
  "item.minecraft.music_disc_pigstep.desc": "Lina Rein- Pigstep",
  "item.minecraft.music_disc_precipice": "Music Disc",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Disiki Orin",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Diski Orin",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Diski Orin",
  "item.minecraft.music_disc_strad.desc": "C418 - strad\n",
  "item.minecraft.music_disc_tears": "Music Disc",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Diski Orin",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Diski Orin",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Aise Odidi",
  "item.minecraft.name_tag": "Orukọ Tag",
  "item.minecraft.nautilus_shell": "Ikarahun ti a nautilus",
  "item.minecraft.nautilus_spawn_egg": "Nautilus Spawn Egg",
  "item.minecraft.nether_brick": "Nether Brick",
  "item.minecraft.nether_star": "Nether Irawọ",
  "item.minecraft.nether_wart": "Nether Wart",
  "item.minecraft.netherite_axe": "Ax ti Netherite",
  "item.minecraft.netherite_boots": "Awọn bata Netherite",
  "item.minecraft.netherite_chestplate": "Chestpiece Netherite",
  "item.minecraft.netherite_helmet": "Helmiteite",
  "item.minecraft.netherite_hoe": "Hoe Xite",
  "item.minecraft.netherite_horse_armor": "Netherite Horse Armor",
  "item.minecraft.netherite_ingot": "Netherite Ingot",
  "item.minecraft.netherite_leggings": "Leggings Netherite",
  "item.minecraft.netherite_nautilus_armor": "Netherite Nautilus Armor",
  "item.minecraft.netherite_pickaxe": "Pickaxe ti Netherite",
  "item.minecraft.netherite_scrap": "Alokuirin Netherite",
  "item.minecraft.netherite_shovel": "Ṣẹgun Netherite",
  "item.minecraft.netherite_spear": "Netherite Spear",
  "item.minecraft.netherite_sword": "Idà Netherite",
  "item.minecraft.netherite_upgrade_smithing_template": "Smithing Template",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherite Upgrade",
  "item.minecraft.oak_boat": "Okọ oju omi oaku",
  "item.minecraft.oak_chest_boat": "Egbe igi oak pẹlu àyà",
  "item.minecraft.ocelot_spawn_egg": "Ẹyin pe Ocelot",
  "item.minecraft.ominous_bottle": "Ominous Bottle",
  "item.minecraft.ominous_trial_key": "Ominous Trial Key",
  "item.minecraft.orange_bundle": "Orange Bundle",
  "item.minecraft.orange_dye": "Oyinbo Osan",
  "item.minecraft.orange_harness": "Orange Harness",
  "item.minecraft.painting": "Kikun",
  "item.minecraft.pale_oak_boat": "Pale Oak Boat",
  "item.minecraft.pale_oak_chest_boat": "Pale Oak Boat with Chest",
  "item.minecraft.panda_spawn_egg": "Ṣiṣẹda panda",
  "item.minecraft.paper": "Iwe",
  "item.minecraft.parched_spawn_egg": "Parched Spawn Egg",
  "item.minecraft.parrot_spawn_egg": "Ẹyin pe ikẹjọ kan",
  "item.minecraft.phantom_membrane": "Awọ-ara koriko",
  "item.minecraft.phantom_spawn_egg": "Ẹyin pe pipe kan",
  "item.minecraft.pig_spawn_egg": "Ẹyin pipe kan ẹlẹdẹ",
  "item.minecraft.piglin_banner_pattern": "Apẹẹrẹ asia",
  "item.minecraft.piglin_banner_pattern.desc": "Imu",
  "item.minecraft.piglin_banner_pattern.new": "Snout Banner Pattern",
  "item.minecraft.piglin_brute_spawn_egg": "Brutal Piglin Summon Eri",
  "item.minecraft.piglin_spawn_egg": "Ẹjẹ Piglin Summon",
  "item.minecraft.pillager_spawn_egg": "Ṣiṣe buburu",
  "item.minecraft.pink_bundle": "Pink Bundle",
  "item.minecraft.pink_dye": "Pink Dai",
  "item.minecraft.pink_harness": "Pink Harness",
  "item.minecraft.pitcher_plant": "Pitcher ọgbin",
  "item.minecraft.pitcher_pod": "Pitcher Labẹ",
  "item.minecraft.plenty_pottery_shard": "Opolopo Iseamokoko Shard",
  "item.minecraft.plenty_pottery_sherd": "Opolopo Iseamokoko Sherd",
  "item.minecraft.poisonous_potato": "Majele ti Ọdunkun",
  "item.minecraft.polar_bear_spawn_egg": "Ẹyin ti o pe ni agbọn pola kan",
  "item.minecraft.popped_chorus_fruit": "Ti jade Chorus Eso",
  "item.minecraft.porkchop": "Aise ẹlẹdẹ ẹlẹdẹ",
  "item.minecraft.potato": "Ọdunkun",
  "item.minecraft.potion": "Ikoko",
  "item.minecraft.potion.effect.awkward": "Àìrọrùn Iwon",
  "item.minecraft.potion.effect.empty": "Ikoko Ti ko ṣee gbe",
  "item.minecraft.potion.effect.fire_resistance": "Iwon ti Ina Atako",
  "item.minecraft.potion.effect.harming": "Iwon ti Ipalara",
  "item.minecraft.potion.effect.healing": "Iwon ti Iwosan",
  "item.minecraft.potion.effect.infested": "Potion of Infestation",
  "item.minecraft.potion.effect.invisibility": "Iwon ti Alaihan",
  "item.minecraft.potion.effect.leaping": "Iwon ti Fifo",
  "item.minecraft.potion.effect.levitation": "Iwon ti Lefeti",
  "item.minecraft.potion.effect.luck": "Iwon ti Orire",
  "item.minecraft.potion.effect.mundane": "Mundane Iwon",
  "item.minecraft.potion.effect.night_vision": "Iwon ti Alẹ Iran",
  "item.minecraft.potion.effect.oozing": "Potion of Oozing",
  "item.minecraft.potion.effect.poison": "Iwon ti Majele",
  "item.minecraft.potion.effect.regeneration": "Iwon ti Isọdọtun",
  "item.minecraft.potion.effect.slow_falling": "Ẹdun ti ilọkuro sisẹ",
  "item.minecraft.potion.effect.slowness": "Iwon ti Fifalẹ",
  "item.minecraft.potion.effect.strength": "Iwon ti Agbara",
  "item.minecraft.potion.effect.swiftness": "Iwon ti Kánkán",
  "item.minecraft.potion.effect.thick": "Nipọn Iwon",
  "item.minecraft.potion.effect.turtle_master": "Ẹkuru kan ti o ni erupẹ",
  "item.minecraft.potion.effect.water": "Igo Omi",
  "item.minecraft.potion.effect.water_breathing": "Iwon ti Omi Mimi",
  "item.minecraft.potion.effect.weakness": "Iwon ti Ailera",
  "item.minecraft.potion.effect.weaving": "Potion of Weaving",
  "item.minecraft.potion.effect.wind_charged": "Potion of Wind Charging",
  "item.minecraft.pottery_shard_archer": "Archer apadì o Shard",
  "item.minecraft.pottery_shard_arms_up": "Arms Up apadì o Shard",
  "item.minecraft.pottery_shard_prize": "Prize Pottery Shard",
  "item.minecraft.pottery_shard_skull": "Timole apadì o Shard",
  "item.minecraft.powder_snow_bucket": "Powder Egbon Garawa",
  "item.minecraft.prismarine_crystals": "Awọn kirisita Prismarine",
  "item.minecraft.prismarine_shard": "Prismarine Shard",
  "item.minecraft.prize_pottery_shard": "Prize Pottery Shard",
  "item.minecraft.prize_pottery_sherd": "Prize Pottery Sherd",
  "item.minecraft.pufferfish": "Pufferfish",
  "item.minecraft.pufferfish_bucket": "Garawa pẹlu fifaju",
  "item.minecraft.pufferfish_spawn_egg": "Ẹyin pe pipe kan",
  "item.minecraft.pumpkin_pie": "Elegede Paii",
  "item.minecraft.pumpkin_seeds": "Awọn irugbin Elegede",
  "item.minecraft.purple_bundle": "Purple Bundle",
  "item.minecraft.purple_dye": "Aro Eleyi",
  "item.minecraft.purple_harness": "Purple Harness",
  "item.minecraft.quartz": "Nether Quartz",
  "item.minecraft.rabbit": "Ehoro aise",
  "item.minecraft.rabbit_foot": "Ẹsẹ Ehoro",
  "item.minecraft.rabbit_hide": "Ìbòmọlẹ Ehoro",
  "item.minecraft.rabbit_spawn_egg": "Ẹyin pe ehoro",
  "item.minecraft.rabbit_stew": "Ehoro Ipẹtẹ",
  "item.minecraft.raiser_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Raiser Armor Trim",
  "item.minecraft.ravager_spawn_egg": "Ṣẹda akọmalu",
  "item.minecraft.raw_copper": "Ejò Aise",
  "item.minecraft.raw_gold": "Raw Gold",
  "item.minecraft.raw_iron": "Aise Aise",
  "item.minecraft.recovery_compass": "Kompasi imularada",
  "item.minecraft.red_bundle": "Red Bundle",
  "item.minecraft.red_dye": "Red lulú",
  "item.minecraft.red_harness": "Red Harness",
  "item.minecraft.redstone": "Redstone lulú",
  "item.minecraft.resin_brick": "Resin Brick",
  "item.minecraft.resin_clump": "Resin Clump",
  "item.minecraft.rib_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rib Armor Trim",
  "item.minecraft.rotten_flesh": "Eran run",
  "item.minecraft.saddle": "Gàárì",
  "item.minecraft.salmon": "Salmoni Aise",
  "item.minecraft.salmon_bucket": "Akara pẹlu iru ẹja nla kan",
  "item.minecraft.salmon_spawn_egg": "Ẹyin pipe fun iru ẹja nla kan",
  "item.minecraft.scrape_pottery_sherd": "Scrape Pottery Sherd",
  "item.minecraft.scute": "Scute",
  "item.minecraft.sentry_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Sentry Armor Trim",
  "item.minecraft.shaper_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Shaper Armor Trim",
  "item.minecraft.sheaf_pottery_shard": "Sheaf Iseamokoko Shard",
  "item.minecraft.sheaf_pottery_sherd": "Sheaf Iseamokoko Sherd",
  "item.minecraft.shears": "Shears",
  "item.minecraft.sheep_spawn_egg": "Ẹyin pe agutan",
  "item.minecraft.shelter_pottery_shard": "Koseemani apadì o Shard",
  "item.minecraft.shelter_pottery_sherd": "Koseemani apadì o Sherd",
  "item.minecraft.shield": "Apata",
  "item.minecraft.shield.black": "Aṣọ Dudu",
  "item.minecraft.shield.blue": "Awọ Blue",
  "item.minecraft.shield.brown": "Shield Brown",
  "item.minecraft.shield.cyan": "Apata Cyan",
  "item.minecraft.shield.gray": "Awọ Grẹy",
  "item.minecraft.shield.green": "Shield Alawọ ewe",
  "item.minecraft.shield.light_blue": "Awọ Blue Shield",
  "item.minecraft.shield.light_gray": "Awọ Grey Grey",
  "item.minecraft.shield.lime": "Apamọwọ Orombo wewe",
  "item.minecraft.shield.magenta": "Shienta Magenta",
  "item.minecraft.shield.orange": "Apata Osan",
  "item.minecraft.shield.pink": "Awọ Pink",
  "item.minecraft.shield.purple": "Shield eleyi",
  "item.minecraft.shield.red": "Aabo Pupa",
  "item.minecraft.shield.white": "Aṣọ funfun",
  "item.minecraft.shield.yellow": "Shield Shield",
  "item.minecraft.shulker_shell": "Ikarahun Shulker",
  "item.minecraft.shulker_spawn_egg": "Ẹyin pe Shulker",
  "item.minecraft.sign": "Wole",
  "item.minecraft.silence_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Silence Armor Trim",
  "item.minecraft.silverfish_spawn_egg": "Ẹyin pe ẹja iha",
  "item.minecraft.skeleton_horse_spawn_egg": "Ẹyin pe ọmọ ẹṣin egungun kan",
  "item.minecraft.skeleton_spawn_egg": "Ẹyin ti n pe egungun",
  "item.minecraft.skull_banner_pattern": "Apẹẹrẹ asia",
  "item.minecraft.skull_banner_pattern.desc": "Agbari Owo-ori",
  "item.minecraft.skull_banner_pattern.new": "Skull Charge Banner Pattern",
  "item.minecraft.skull_pottery_shard": "Timole apadì o Shard",
  "item.minecraft.skull_pottery_sherd": "Timole apadì o Sherd",
  "item.minecraft.slime_ball": "Slimeball",
  "item.minecraft.slime_spawn_egg": "Ẹyin pe Slime",
  "item.minecraft.smithing_template": "Smithing Àdàkọ",
  "item.minecraft.smithing_template.applies_to": "Kan si:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Fi ingot tabi gara",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Ihamọra",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Fi kan nkan ti ihamọra",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Ingots & Kirisita",
  "item.minecraft.smithing_template.ingredients": "Eroja:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Fi Netherite Ingot kun",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamond Equipment",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Ṣafikun ihamọra diamond, ohun ija, tabi irinṣẹ",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netherite Ingot",
  "item.minecraft.smithing_template.upgrade": "Igbesoke: ",
  "item.minecraft.sniffer_spawn_egg": "Ẹyin pipe kan Sniffer",
  "item.minecraft.snort_pottery_shard": "Snort apadì o Shard",
  "item.minecraft.snort_pottery_sherd": "Snort apadì o Sherd",
  "item.minecraft.snout_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Snout Armor Trim",
  "item.minecraft.snow_golem_spawn_egg": "Ẹyin pipe kan Egbon Golem",
  "item.minecraft.snowball": "Bọọlu afẹsẹgba",
  "item.minecraft.spectral_arrow": "Apoti Oju",
  "item.minecraft.spider_eye": "Oju Alantakun",
  "item.minecraft.spider_spawn_egg": "Ẹyin pipe kan Spider",
  "item.minecraft.spire_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Spire Armor Trim",
  "item.minecraft.splash_potion": "Asesejade Iwon",
  "item.minecraft.splash_potion.effect.awkward": "Àìrọra Asesejade Iwon",
  "item.minecraft.splash_potion.effect.empty": "Asesejade Uncraftable Iwon",
  "item.minecraft.splash_potion.effect.fire_resistance": "Asesejade iwon ti Ina Atako",
  "item.minecraft.splash_potion.effect.harming": "Asesejade iwon ti Ipalara",
  "item.minecraft.splash_potion.effect.healing": "Asesejade iwon ti Iwosan",
  "item.minecraft.splash_potion.effect.infested": "Splash Potion of Infestation",
  "item.minecraft.splash_potion.effect.invisibility": "Asesejade iwon ti Alaihan",
  "item.minecraft.splash_potion.effect.leaping": "Asesejade iwon ti Fifo",
  "item.minecraft.splash_potion.effect.levitation": "Asesejade iwon ti Levitation",
  "item.minecraft.splash_potion.effect.luck": "Asesejade iwon ti Orire",
  "item.minecraft.splash_potion.effect.mundane": "Mundane Asesejade Iwon",
  "item.minecraft.splash_potion.effect.night_vision": "Asesejade iwon ti Alẹ Iran",
  "item.minecraft.splash_potion.effect.oozing": "Splash Potion of Oozing",
  "item.minecraft.splash_potion.effect.poison": "Asesejade iwon ti Majele",
  "item.minecraft.splash_potion.effect.regeneration": "Asesejade iwon ti Olooru",
  "item.minecraft.splash_potion.effect.slow_falling": "Mu fifọ pọ simẹnti",
  "item.minecraft.splash_potion.effect.slowness": "Asesejade iwon ti Laiyara",
  "item.minecraft.splash_potion.effect.strength": "Asesejade iwon ti Agbara",
  "item.minecraft.splash_potion.effect.swiftness": "Asesejade iwon ti Kánkán",
  "item.minecraft.splash_potion.effect.thick": "Nipọn Asesejade Asọ",
  "item.minecraft.splash_potion.effect.turtle_master": "Isọpọ ikoko ti oludari erupẹ",
  "item.minecraft.splash_potion.effect.water": "Asọ Omi Asọ",
  "item.minecraft.splash_potion.effect.water_breathing": "Asesejade iwon ti Omi Mimi",
  "item.minecraft.splash_potion.effect.weakness": "Asesejade iwon ti Ailera",
  "item.minecraft.splash_potion.effect.weaving": "Splash Potion of Weaving",
  "item.minecraft.splash_potion.effect.wind_charged": "Splash Potion of Wind Charging",
  "item.minecraft.spruce_boat": "Okọ oju omi spruce",
  "item.minecraft.spruce_chest_boat": "Spruce Boat pẹlu àyà",
  "item.minecraft.spyglass": "Spyglass",
  "item.minecraft.squid_spawn_egg": "Ẹyin pe pipe kan",
  "item.minecraft.stick": "Lẹẹmọ",
  "item.minecraft.stone_axe": "Apata Okuta",
  "item.minecraft.stone_hoe": "Hoe Stone",
  "item.minecraft.stone_pickaxe": "Onigi Pickaxe",
  "item.minecraft.stone_shovel": "Isele irin",
  "item.minecraft.stone_spear": "Stone Spear",
  "item.minecraft.stone_sword": "Idà Stone",
  "item.minecraft.stray_spawn_egg": "Ẹyin ti o pe ni aṣiṣe naa",
  "item.minecraft.strider_spawn_egg": "Onje itaja Summon Egg",
  "item.minecraft.string": "Okun",
  "item.minecraft.sugar": "Suga",
  "item.minecraft.suspicious_stew": "Ipanu ifura",
  "item.minecraft.sweet_berries": "Sweet eso",
  "item.minecraft.tadpole_bucket": "Garawa ti Tadpole",
  "item.minecraft.tadpole_spawn_egg": "Tadpole Spawn Ẹyin",
  "item.minecraft.tide_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Tide Armor Trim",
  "item.minecraft.tipped_arrow": "Arrow olorun",
  "item.minecraft.tipped_arrow.effect.awkward": "Tifa Ọfa",
  "item.minecraft.tipped_arrow.effect.empty": "Ọfa Ti a ko le gbe jade",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Ọfa ti Ina Atako",
  "item.minecraft.tipped_arrow.effect.harming": "Ọfa ti Ipalara",
  "item.minecraft.tipped_arrow.effect.healing": "Ọfa ti Iwosan",
  "item.minecraft.tipped_arrow.effect.infested": "Arrow of Infestation",
  "item.minecraft.tipped_arrow.effect.invisibility": "Ọfà ti Alaihan",
  "item.minecraft.tipped_arrow.effect.leaping": "Ọfa ti Fifo",
  "item.minecraft.tipped_arrow.effect.levitation": "Ọfa ti Lefeti",
  "item.minecraft.tipped_arrow.effect.luck": "Ọfa ti Orire",
  "item.minecraft.tipped_arrow.effect.mundane": "Tifa Ọfa",
  "item.minecraft.tipped_arrow.effect.night_vision": "Ọfa ti Alẹ Iran",
  "item.minecraft.tipped_arrow.effect.oozing": "Arrow of Oozing",
  "item.minecraft.tipped_arrow.effect.poison": "Ọfa ti Majele",
  "item.minecraft.tipped_arrow.effect.regeneration": "Ọfa ti Isọdọtun",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Orilẹ-ede ti isunku fifọ",
  "item.minecraft.tipped_arrow.effect.slowness": "Arrow of Fifalẹ",
  "item.minecraft.tipped_arrow.effect.strength": "Ọfa ti Agbara",
  "item.minecraft.tipped_arrow.effect.swiftness": "Ọfa ti Kánkán",
  "item.minecraft.tipped_arrow.effect.thick": "Tifa Ọfa",
  "item.minecraft.tipped_arrow.effect.turtle_master": "A shot kan ti Ẹkuru titunto si",
  "item.minecraft.tipped_arrow.effect.water": "Ọfà ti Splashing",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Ọfa ti Omi Mimi",
  "item.minecraft.tipped_arrow.effect.weakness": "Ọfa ti Ailera",
  "item.minecraft.tipped_arrow.effect.weaving": "Arrow of Weaving",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Arrow of Wind Charging",
  "item.minecraft.tnt_minecart": "Minecart pẹlu TNT",
  "item.minecraft.torchflower_seeds": "Ògùṣọ Flower irugbin na",
  "item.minecraft.totem_of_undying": "Totem ti Iku",
  "item.minecraft.trader_llama_spawn_egg": "Ṣẹda onisowo oniṣowo kan",
  "item.minecraft.trial_key": "Trial Key",
  "item.minecraft.trident": "Trident",
  "item.minecraft.tropical_fish": "Ipa ọna oorun eja",
  "item.minecraft.tropical_fish_bucket": "Ogo kan pẹlu ẹja ti oorun",
  "item.minecraft.tropical_fish_spawn_egg": "Ẹyin pe pipe eja ti nwaye",
  "item.minecraft.turtle_helmet": "Ipele ijapa",
  "item.minecraft.turtle_scute": "Turtle Scute",
  "item.minecraft.turtle_spawn_egg": "Ẹyin pe ikoko kan",
  "item.minecraft.vex_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Vex Armor Trim",
  "item.minecraft.vex_spawn_egg": "Ẹyin pe ikorira",
  "item.minecraft.villager_spawn_egg": "Ẹyin pe olutọju naa",
  "item.minecraft.vindicator_spawn_egg": "Ẹyin pe pipe kan",
  "item.minecraft.wandering_trader_spawn_egg": "Ṣẹda onikan iṣowo",
  "item.minecraft.ward_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ward Armor Trim",
  "item.minecraft.warden_spawn_egg": "Warden Spawn Ẹyin",
  "item.minecraft.warped_fungus_on_a_stick": "Ipeja Olu Olu Ipeja",
  "item.minecraft.water_bucket": "Garawa Omi",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Wayfinder Armor Trim",
  "item.minecraft.wheat": "Alikama",
  "item.minecraft.wheat_seeds": "Irugbin alikama",
  "item.minecraft.white_bundle": "White Bundle",
  "item.minecraft.white_dye": "Funfun dai",
  "item.minecraft.white_harness": "White Harness",
  "item.minecraft.wild_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Wild Armor Trim",
  "item.minecraft.wind_charge": "Wind Charge",
  "item.minecraft.witch_spawn_egg": "Ẹyin pe ọrẹ kan",
  "item.minecraft.wither_skeleton_spawn_egg": "Ẹyin ti n pe Wither egungun",
  "item.minecraft.wither_spawn_egg": "Wither Spawn Ẹyin",
  "item.minecraft.wolf_armor": "Wolf Armor",
  "item.minecraft.wolf_spawn_egg": "Ẹyin pe ikoko kan",
  "item.minecraft.wooden_axe": "Axe onigi",
  "item.minecraft.wooden_hoe": "Onigi Hoe",
  "item.minecraft.wooden_pickaxe": "Onigi Pickaxe",
  "item.minecraft.wooden_shovel": "Onigi Shovel",
  "item.minecraft.wooden_spear": "Wooden Spear",
  "item.minecraft.wooden_sword": "Idà Igi",
  "item.minecraft.writable_book": "Iwe ati ki o Quill",
  "item.minecraft.written_book": "Iwe ti a Kọ",
  "item.minecraft.yellow_bundle": "Yellow Bundle",
  "item.minecraft.yellow_dye": "Awọ Ofeefee",
  "item.minecraft.yellow_harness": "Yellow Harness",
  "item.minecraft.zoglin_spawn_egg": "Zoglin Summon Igba",
  "item.minecraft.zombie_horse_spawn_egg": "Ẹyin pe Zombie ẹṣin",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombie Nautilus Spawn Egg",
  "item.minecraft.zombie_spawn_egg": "Ẹyin pe Zombie",
  "item.minecraft.zombie_villager_spawn_egg": "Ẹyin pe olutọju Zombie naa",
  "item.minecraft.zombified_piglin_spawn_egg": "Zombie Piglin Summon Igba"
}
export const yo_ng = items; 
